/* Конторские экраны, кириллица. Ключ — русская фраза.

   Собирается из партий tr-*.cjs в tools/i18n; править здесь
   бессмысленно, правка потеряется при следующей сборке.
   Устройство и причина такого ключа — в office.js.

   ТРЕБУЕТ ВЫЧИТКИ НОСИТЕЛЕМ НА ЗАВОДЕ ДО ЗАПУСКА. */

export default {
  'Отмена': 'Бекор қилиш',
  'Обновить': 'Янгилаш',
  'Партия': 'Партия',
  'Материал': 'Материал',
  'Закрыть': 'Ёпиш',
  'Заказ': 'Буюртма',
  'Изделие': 'Маҳсулот',
  'Название': 'Номи',
  '— выберите —': '— танланг —',
  'Когда': 'Қачон',
  'Код': 'Код',
  'Причина': 'Сабаб',
  'Станок': 'Дастгоҳ',
  'Вид': 'Тури',
  'Кто': 'Ким',
  'Оборудование': 'Ускуна',
  'Примечание': 'Эслатма',
  'Состояние': 'Ҳолат',
  '— выберите материал —': '— материални танланг —',
  'Включить': 'Ёқиш',
  'загрузка…': 'юкланмоқда…',
  'Качество': 'Сифат',
  'Количество': 'Миқдор',
  'Номер': 'Рақам',
  'отключён': 'ўчирилган',
  'Отключить': 'Ўчириш',
  'Пометка': 'Белги',
  'Правка': 'Таҳрирлаш',
  'Срок': 'Муддат',
  'Убрать': 'Олиб ташлаш',
  'Уровень': 'Даража',
  'Готово': 'Тайёр',
  'Дата': 'Сана',
  'Добавить': 'Қўшиш',
  'Документ продаж': 'Сотув ҳужжати',
  'Доступность': 'Мавжудлик',
  'Ед.': 'Бирл.',
  'Завести': 'Киритиш',
  'Загрузка…': 'Юкланмоқда…',
  'Заказы': 'Буюртмалар',
  'Комментарий': 'Изоҳ',
  'Не более': 'Кўпи билан',
  'Не менее': 'Ками билан',
  'Операция': 'Операция',
  'Осталось': 'Қолди',
  'Откуда': 'Қаердан',
  'Показатель': 'Кўрсаткич',
  'показывать отключённые': 'ўчирилганларни кўрсатиш',
  'Применить': 'Қўллаш',
  'Производительность': 'Унумдорлик',
  'Происхождение': 'Келиб чиқиши',
  'Сертификат': 'Сертификат',
  'Смена': 'Смена',
  'Смены': 'Сменалар',
  'Станки': 'Дастгоҳлар',
  'Статус': 'Статус',
  'Сторно': 'Сторно',
  'Уровень качества': 'Сифат даражаси',
  'Участок': 'Участка',
  '— не присвоен —': '— берилмаган —',
  '· события недоступны': '· ҳодисалар мавжуд эмас',
  'аннулирован': 'кучдан қолдирилган',
  'Аннулировать': 'Кучдан қолдириш',
  'Брак': 'Яроқсиз',
  'В работе': 'Ишда',
  'В цехе': 'Сехда',
  'Вс': 'Якш',
  'Вт': 'Се',
  'Входной материал': 'Кирувчи материал',
  'Выдать': 'Бериш',
  'да': 'ҳа',
  'Единица': 'Бирлик',
  'Заказчик': 'Буюртмачи',
  'Записать': 'Ёзиш',
  'Календарь': 'Календарь',
  'Кол-во': 'Миқд.',
  'Контрагент': 'Контрагент',
  'Куда': 'Қаерга',
  'Материалы': 'Материаллар',
  'на партию': 'партияга',
  'Направление': 'Йўналиш',
  'Настройка': 'Созлаш',
  'Не установлено': 'Ўрнатилмаган',
  'Номер партии': 'Партия рақами',
  'Номер сертификата': 'Сертификат рақами',
  'Операции': 'Операциялар',
  'Оснастка и инструмент': 'Асбоб ва ускуна',
  'Перевыпустить': 'Қайта чиқариш',
  'Перевыпустить токен': 'Токенни қайта чиқариш',
  'План': 'Режа',
  'Плановое время': 'Режадаги вақт',
  'Пн': 'Ду',
  'Позиция': 'Позиция',
  'Порядок': 'Тартиб',
  'Порядок в списке': 'Рўйхатдаги тартиб',
  'Последний раз': 'Охирги марта',
  'Поставщик': 'Етказиб берувчи',
  'Предприятие': 'Корхона',
  'Предъявлено': 'Тақдим этилган',
  'Предыдущий передел': 'Олдинги босқич',
  'Принято': 'Қабул қилинган',
  'Приоритет': 'Устуворлик',
  'Прогресс': 'Бажарилиши',
  'Продукция': 'Маҳсулот',
  'Производство': 'Ишлаб чиқариш',
  'Прошло маршрут до конца': 'Маршрутни охиригача ўтди',
  'Пт': 'Жу',
  'Сб': 'Ша',
  'Свой передел': 'Ўз босқичи',
  'Сколько': 'Қанча',
  'Сохранить': 'Сақлаш',
  'Ср': 'Чо',
  'Сторнировать': 'Сторно қилиш',
  'Табельный': 'Табел',
  'Такт, сек/ед': 'Такт, сек/бирл.',
  'Тара под лом': 'Чиқинди идиши',
  'Тип': 'Тури',
  'Фактически': 'Амалда',
  'Химия плавки': 'Эритма кимёси',
  'Чт': 'Пай',
  'Что это': 'Бу нима',
  '— аннулирован': '— кучдан қолдирилган',
  '— без сертификата —': '— сертификатсиз —',
  '— вид операции —': '— операция тури —',
  '— выберите зону —': '— зонани танланг —',
  '— выберите партию —': '— партияни танланг —',
  '— выберите регламент —': '— регламентни танланг —',
  '— выберите станок —': '— дастгоҳни танланг —',
  '— не задан —': '— берилмаган —',
  '— не задано —': '— берилмаган —',
  '— не назначен': '— тайинланмаган',
  '— не присвоено —': '— берилмаган —',
  '— не указана —': '— кўрсатилмаган —',
  '— обязателен для этой причины': '— бу сабаб учун мажбурий',
  '— обязательна': '— мажбурий',
  '— оператор выбирает сам —': '— оператор ўзи танлайди —',
  '— поправьте, иначе событие по ним будет отклонено': '— тўғриланг, акс ҳолда улар бўйича ҳодиса рад этилади',
  '— при необходимости': '— зарур бўлса',
  '— причина —': '— сабаб —',
  '— тип не меняется: у узла есть потомки и привязанные данные': '— тури ўзгармайди: тугунда авлодлар ва боғланган маълумотлар бор',
  '— участок не задан —': '— участка берилмаган —',
  '— фактических данных пока нет, считаем по нормативу': '— амалдаги маълумотлар ҳали йўқ, норма бўйича ҳисобланмоқда',
  '. На столько дата и сдвинулась.': '. Сана ҳам шунчага сурилди.',
  '· без документа продаж': '· сотув ҳужжатисиз',
  '· ждут': '· кутмоқда',
  '· норматив завышен либо не учтено время работы': '· норма ошириб белгиланган ёки иш вақти ҳисобга олинмаган',
  '· обрезано по размеру': '· ҳажми бўйича қисқартирилди',
  '· ожидают': '· кутмоқда',
  '· просрочено': '· муддати ўтган',
  '· требуют решения': '· қарор талаб қилади',
  '«В цехе» — остаток по всем зонам хранения. Склад предприятия ведётся отдельно': '«Сехда» — барча сақлаш зоналари бўйича қолдиқ. Корхона омбори алоҳида юритилади',
  '«Использовать как есть» без обоснования не принимается: на него будут ссылаться при рекламации': '«Бор ҳолича ишлатиш» асоссиз қабул қилинмайди: рекламацияда унга ҳавола қилинади',
  '«Нашла» — смена, обнаружившая брак. «Сделала» — та, из-за которой он возник': '«Топди» — яроқсизни аниқлаган смена. «Қилди» — у юзага келишига сабаб бўлган смена',
  '«Согласован» сразу замораживает содержимое и разузловывает маршрут': '«Келишилган» мазмунни дарҳол музлатади ва маршрутни ёяди',
  '+ вложенный': '+ ички',
  '+ материал': '+ материал',
  '+ характеристика': '+ тавсиф',
  '0 для штук, 3 для килограммов': 'доналар учун 0, килограммлар учун 3',
  '1 — высший': '1 — энг юқори',
  '3 — обычный': '3 — оддий',
  '4–8 цифр': '4–8 рақам',
  '5 — низший': '5 — энг паст',
  'автоповтор выключен': 'автотакрор ўчирилган',
  'автоповтор остановлен': 'автотакрор тўхтатилган',
  'Активной может быть одна версия на изделие. Правка карты не затрагивает уже разузлованные заказы: их операции зафиксированы копией.': 'Ҳар бир маҳсулот учун битта версия фаол бўлади. Харитани таҳрирлаш маршрути ёйилган буюртмаларга тегмайди: уларнинг операциялари нусха билан қайд этилган.',
  'Анализ': 'Таҳлил',
  'Анализ образца по бирке. Результат становится уровнем партии': 'Намунани бирка бўйича таҳлил қилиш. Натижа партия даражасига айланади',
  'Анализов пока нет. Отсканируйте бирку образца': 'Ҳозирча таҳлиллар йўқ. Намуна биркасини сканерланг',
  'Андон': 'Андон',
  'Аннулировать протокол': 'Баённомани кучдан қолдириш',
  'Аннулировать сертификат': 'Сертификатни кучдан қолдириш',
  'Без затвора — операции закрываются без контролёра': 'Дарвозасиз — операциялар назоратчисиз ёпилади',
  'без ключа': 'калитсиз',
  'без металла:': 'металлсиз:',
  'без норматива': 'нормасиз',
  'Без нормы производительность в OEE посчитается по такту изделия, а если и его нет — не посчитается': 'Нормасиз OEE унумдорлиги маҳсулот такти бўйича ҳисобланади, у ҳам бўлмаса — ҳисобланмайди',
  'Без причины исправление нельзя будет объяснить': 'Сабабсиз тузатишни тушунтириб бўлмайди',
  'Без табельного номера оператор не войдёт на терминале': 'Табел рақамисиз оператор терминалга кира олмайди',
  'Без текста причину нельзя будет выбрать — для случаев, где сама причина ничего не объясняет': 'Матнсиз сабабни танлаб бўлмайди — сабабнинг ўзи ҳеч нимани тушунтирмайдиган ҳоллар учун',
  'Без указанной причины': 'Сабаб кўрсатилмаган',
  'без штрихкода': 'штрих-кодсиз',
  'Бирка': 'Бирка',
  'брак': 'яроқсиз',
  'Брак / дефект': 'Яроқсиз / нуқсон',
  'Брак и дефекты': 'Яроқсиз ва нуқсонлар',
  'Брак по партиям происхождения': 'Келиб чиқиш партиялари бўйича яроқсиз',
  'Брака': 'Яроқсиз',
  'Бункер заводится пустым и наполняется загрузками': 'Бункер бўш ҳолда очилади ва юкламалар билан тўлдирилади',
  'Бункер пуст. Брак попадёт сюда сам, когда оператор отметит его у станка': 'Бункер бўш. Оператор дастгоҳ ёнида белгилаганда яроқсиз бу ерга ўзи тушади',
  'Бункеры': 'Бункерлар',
  'Буферная зона': 'Буфер зонаси',
  'В документ попадёт всё, что о партии известно: уровень, химия из последнего протокола, происхождение по родословной. Ничего вводить не нужно': 'Ҳужжатга партия ҳақида маълум бўлган ҳамма нарса тушади: даража, охирги баённомадаги кимё, келиб чиқиш занжири. Ҳеч нима киритиш шарт эмас',
  'В маршруте нет ни одной начальной операции — поток некуда подать. Снимите связи у той, с которой всё начинается': 'Маршрутда бирорта бошланғич операция йўқ — оқимни беришга жой йўқ. Ҳаммаси бошланадиган операциядан боғланишларни олинг',
  'в норме': 'меъёрда',
  'В норме': 'Меъёрда',
  'В норму закладывается технологический отход: если из прутка выходит 5 деталей вместо 6, норма считается по факту, а не по чертежу': 'Нормага технологик чиқинди киритилади: стержендан 6 эмас, 5 дона чиқса, норма чизма бўйича эмас, амалдаги ҳолат бўйича ҳисобланади',
  'В обороте': 'Айланмада',
  'в порядке': 'жойида',
  'В потери': 'Йўқотишларга',
  'в работе': 'ишда',
  'в ТО': 'техник хизматда',
  'В печь тару отправляет плавильщик — отсканирует её на экране навески. Кнопки «в переплав» здесь нет намеренно: металл едет по факту, а не по нажатию': 'Идишни печга эритувчи юборади — уни шихта экранида сканерлайди. «Қайта эритишга» тугмаси бу ерда атайлаб йўқ: металл тугма босилгани учун эмас, амалда кетади',
  'В тоннах': 'Тоннада',
  'В цехе материалов нет. Оформите поступление на участок — это момент, когда материал переехал из кладовой в цех': 'Сехда материал йўқ. Участкага киримни расмийлаштиринг — бу материал омборхонадан сехга ўтган пайт',
  'В чём меряется выпуск этой операции': 'Бу операция маҳсулоти нимада ўлчанади',
  'Введите фактический расход — систему к нему приведём сами': 'Амалдаги сарфни киритинг — тизимни унга ўзимиз келтирамиз',
  'Вернуть как было': 'Аввалги ҳолига қайтариш',
  'Вернуть поставщику': 'Етказиб берувчига қайтариш',
  'Версия': 'Версия',
  'Вес': 'Вазн',
  'Вес единицы задаётся в номенклатуре': 'Бирлик вазни номенклатурада берилади',
  'вес единицы не задан': 'бирлик вазни берилмаган',
  'Вес единицы, кг': 'Бирлик вазни, кг',
  'Вес, кг': 'Вазн, кг',
  'Вести по партиям': 'Партиялар бўйича юритиш',
  'весь завод': 'бутун завод',
  'Весь завод': 'Бутун завод',
  'Вид операции — словарь техпроцесса заказчика. Его умолчания подставляются в маршрутную карту, где их можно переопределить.': 'Операция тури — буюртмачи техжараёнининг луғати. Унинг стандарт қийматлари маршрут харитасига қўйилади ва у ерда ўзгартирилиши мумкин.',
  'Вид определяет только префикс кода. Он не ограничивает, что за биркой окажется': 'Тури фақат код префиксини белгилайди. Бирка ортида нима бўлишини у чекламайди',
  'Видит производство целиком, может всё, что планировщик и мастер': 'Ишлаб чиқаришни бутунлай кўради, режалаштирувчи ва смена бошлиғи қила оладиган ҳамма нарсани қила олади',
  'Виды операций': 'Операция турлари',
  'Виды планового обслуживания. Плановое ТО не входит в плановое время OEE': 'Режали хизмат кўрсатиш турлари. Режали техник хизмат OEE режали вақтига кирмайди',
  'Вложен в предприятие': 'Корхонага жойлашган',
  'Вложен в цех. К нему привязываются виды операций': 'Сехга жойлашган. Унга операция турлари боғланади',
  'Вместимость': 'Сиғими',
  'вне нормы': 'меъёрдан ташқари',
  'Внеплановая': 'Режадан ташқари',
  'Внеплановая работа': 'Режадан ташқари иш',
  'внеплановый': 'режадан ташқари',
  'Внёс': 'Киритди',
  'внесли вы — одобряет другой': 'сиз киритдингиз — бошқаси тасдиқлайди',
  'Внести протокол': 'Баённома киритиш',
  'Возобновить': 'Давом эттириш',
  'Впишите его на планшете при первом входе оператора': 'Оператор биринчи марта кирганда уни планшетга ёзинг',
  'впритык': 'зўрға етади',
  'Время': 'Вақт',
  'Время работы': 'Иш вақти',
  'Время работы станка не записано — OEE посчитан по нулевому знаменателю': 'Дастгоҳнинг иш вақти ёзилмаган — OEE нол махражга ҳисобланган',
  'Время работы станка не записано — OEE посчитан по нулевому знаменателю и ничего не показывает': 'Дастгоҳнинг иш вақти ёзилмаган — OEE нол махражга ҳисобланган ва ҳеч нимани кўрсатмайди',
  'Все': 'Ҳаммаси',
  'Все внесённые протоколы прошли решение контролёра. Пока протокол не одобрен, сертификат на партию не выписывается.': 'Киритилган барча баённомалар назоратчи қароридан ўтган. Баённома тасдиқланмагунча партияга сертификат ёзилмайди.',
  'Все доступные': 'Барча мавжудлари',
  'Все зоны хранения': 'Барча сақлаш зоналари',
  'Всё необходимое настроено': 'Керакли ҳамма нарса созланган',
  'Всё предприятие': 'Бутун корхона',
  'Все роли': 'Барча роллар',
  'всё сохранено': 'ҳаммаси сақланди',
  'всего': 'жами',
  'вход маршрута': 'маршрут кириши',
  'Входное сырьё': 'Кирувчи хомашё',
  'Выберите бункер, чтобы увидеть, что в нём': 'Ичида нима борлигини кўриш учун бункерни танланг',
  'Выберите вид операции': 'Операция турини танланг',
  'Выберите материал': 'Материални танланг',
  'Выберите регламент — или отметьте работу как внеплановую': 'Регламентни танланг — ёки ишни режадан ташқари деб белгиланг',
  'Выберите станок': 'Дастгоҳни танланг',
  'Выберите участок или цех наверху — задание выдаётся на них, а не на весь цех сразу.': 'Юқорида участка ёки сехни танланг — топшириқ бутун сехга эмас, уларга берилади.',
  'Выбираются мастером при переводе станка в аварию. Влияют на Парето потерь времени': 'Дастгоҳни аварияга ўтказишда смена бошлиғи танлайди. Вақт йўқотишлари Паретосига таъсир қилади',
  'Выбираются оператором при отметке окончательного брака. Без них брак нельзя зарегистрировать': 'Оператор якуний яроқсизни белгилаганда танлайди. Уларсиз яроқсизни қайд этиб бўлмайди',
  'Выбираются оператором при приостановке операции и мастером при смене задания': 'Операцияни тўхтатиб туришда оператор, топшириқни алмаштиришда смена бошлиғи танлайди',
  'Выбираются при отметке исправимого дефекта': 'Тузатса бўладиган нуқсонни белгилашда танланади',
  'выбор': 'танлов',
  'выбор не нужен': 'танлов керак эмас',
  'Выгрузить наряды за месяц': 'Ой нарядларини юклаб олиш',
  'Выгрузка наполняет список кодов. Соответствия проставляет человек: совпадение «Катодная медь М00к» и «Медь М00к» очевидно вам и не очевидно программе, а неверное соответствие отправит расход не того материала.': 'Юклаш кодлар рўйхатини тўлдиради. Мосликни одам қўяди: «Катодная медь М00к» ва «Медь М00к» мос келиши сизга равшан, дастурга эса йўқ, нотўғри мослик эса бошқа материалнинг сарфини юборади.',
  'Выдан': 'Берилган',
  'Выдан с оговорками. См. примечание.': 'Изоҳлар билан берилган. Эслатмага қаранг.',
  'Выдана': 'Берилган',
  'Выданные': 'Берилганлар',
  'Выдать бирки': 'Биркаларни бериш',
  'Выдать всё равно можно — остановить отгрузку мы не вправе. Но пояснение станет частью документа и останется в нём навсегда': 'Барибир бериш мумкин — жўнатишни тўхтатишга ҳақимиз йўқ. Аммо изоҳ ҳужжатнинг бир қисмига айланади ва унда абадий қолади',
  'Выдать сертификат с оговоркой': 'Изоҳ билан сертификат бериш',
  'Выделено — нажмите Ctrl+C': 'Белгиланди — Ctrl+C босинг',
  'Выключен': 'Ўчирилган',
  'Выключите для обеда и регламентных перерывов: такое время вычитается из планового, а не считается потерей': 'Тушлик ва регламент танаффуслари учун ўчиринг: бундай вақт йўқотиш эмас, режали вақтдан айирилади',
  'Выпуск': 'Маҳсулот',
  'Выпуск без исполнителя': 'Бажарувчисиз маҳсулот',
  'Выпуск годного по дням': 'Кунлар бўйича яроқли маҳсулот',
  'выпуск не подтверждён мастером': 'маҳсулотни смена бошлиғи тасдиқламаган',
  'Выпуска за смену не зарегистрировано': 'Смена давомида маҳсулот қайд этилмаган',
  'Выпустить': 'Чиқариш',
  'Выпущено годного': 'Яроқли чиқарилди',
  'Выработка': 'Ишлаб чиқариш',
  'Высший': 'Энг юқори',
  'Выход с первого предъявления': 'Биринчи тақдимдан чиқиш',
  'Вычитаются из планового времени в OEE': 'OEE режали вақтидан айирилади',
  'Выше': 'Юқорироқ',
  'Где': 'Қаерда',
  'Где может стоять': 'Қаерда туриши мумкин',
  'Где отмечено «нужен контроль» в маршруте': 'Маршрутда «назорат керак» деб белгиланган жойларда',
  'Где стоит': 'Қаерда турибди',
  'Годен': 'Яроқли',
  'годен / не годен': 'яроқли / яроқсиз',
  'Годен / не годен': 'Яроқли / яроқсиз',
  'Годен до': 'Яроқлилик муддати',
  'Годится к отгрузке': 'Жўнатишга яроқли',
  'годно': 'яроқли',
  'Годных': 'Яроқли',
  'Готовая единица': 'Тайёр бирлик',
  'Готовность контура': 'Контур тайёрлиги',
  'готово': 'тайёр',
  'Границы интервала не меняются — только причина': 'Интервал чегаралари ўзгармайди — фақат сабаб',
  'Группа': 'Гуруҳ',
  'да-нет': 'ҳа-йўқ',
  'Дата документа': 'Ҳужжат санаси',
  'дата неполная': 'сана тўлиқ эмас',
  'Дата поступления': 'Келиб тушган сана',
  'Движений пока нет': 'Ҳозирча ҳаракатлар йўқ',
  'Движения не удаляются — только сторнируются: за каждым стоит бумага, и исправление задним числом должно быть видно': 'Ҳаракатлар ўчирилмайди — фақат сторно қилинади: ҳар бирининг ортида қоғоз туради ва орқага қайтиб тузатиш кўриниб туриши керак',
  'Делайте это при утере устройства или подозрении на компрометацию.': 'Буни қурилма йўқолганда ёки ошкор бўлган деб гумон қилинганда қилинг.',
  'Денег в файле нет: расценки живут в зарплатной системе, а считать сумму в двух местах значит однажды получить два разных ответа': 'Файлда пул йўқ: нархлар иш ҳақи тизимида туради, суммани икки жойда ҳисоблаш эса бир куни икки хил жавоб олиш демакдир',
  'День календаря': 'Календарь куни',
  'Дерево оборудования': 'Ускуналар дарахти',
  'Дерево пусто. Начните с предприятия, затем добавьте цеха, участки и станки.': 'Дарахт бўш. Корхонадан бошланг, сўнг сехлар, участкалар ва дастгоҳларни қўшинг.',
  'Дефект': 'Нуқсон',
  'Длительность': 'Давомийлиги',
  'Для клеёв, красок, паст': 'Елим, бўёқ ва пасталар учун',
  'Для табло и списков. На бирку не печатается — принтер чёрно-белый': 'Табло ва рўйхатлар учун. Биркага босилмайди — принтер оқ-қора',
  'Для чего бирки': 'Биркалар нима учун',
  'дни': 'кун',
  'до переточки': 'қайта чархлашгача',
  'Добавить день': 'Кун қўшиш',
  'Добавить операцию': 'Операция қўшиш',
  'Добавить показатель': 'Кўрсаткич қўшиш',
  'Добавить строку': 'Қатор қўшиш',
  'Добавить табло': 'Табло қўшиш',
  'Добавить терминал': 'Терминал қўшиш',
  'Добавить узел': 'Тугун қўшиш',
  'Договор': 'Шартнома',
  'Документ': 'Ҳужжат',
  'Доли в процентах от всей навески. Окно допуска отдельно от целевой доли: попасть в долю точно невозможно, а требовать этого — значит приучить гасить предупреждение не глядя': 'Бутун шихтадан фоиздаги улушлар. Допуск ойнаси мақсадли улушдан алоҳида: улушга аниқ тушиш мумкин эмас, буни талаб қилиш эса огоҳлантиришни қарамай ўчиришга ўргатиш демакдир',
  'Доля, %': 'Улуш, %',
  'допуск не задан': 'допуск берилмаган',
  'Допустить': 'Рухсат бериш',
  'Доработать': 'Қайта ишлаш',
  'Доставок': 'Етказишлар',
  'Другая партия': 'Бошқа партия',
  'Другой образец': 'Бошқа намуна',
  'Его спрашивают при рекламации': 'Рекламацияда уни сўрашади',
  'Единица измерения': 'Ўлчов бирлиги',
  'Единица, по которой считается OEE': 'OEE ҳисобланадиган бирлик',
  'единицу': 'бирликни',
  'Единицы': 'Бирликлар',
  'Единственный, кто вносит измерения. Решение по несоответствию принимает не он, а мастер': 'Ўлчовларни киритадиган ягона одам. Номувофиқлик бўйича қарорни у эмас, смена бошлиғи қабул қилади',
  'её брак нашли другие': 'унинг яроқсизини бошқалар топган',
  'Если источник неизвестен, заведите партию «сборный лом» и укажите её: у неизвестности должно быть имя, иначе она растворится в общей куче': 'Манба номаълум бўлса, «йиғма чиқинди» партиясини очинг ва уни кўрсатинг: номаълумликнинг номи бўлиши керак, акс ҳолда у умумий уюмда эрийди',
  'Если металл пришёл со стороны': 'Металл четдан келган бўлса',
  'Если раньше начала — смена ночная': 'Бошланишидан олдин бўлса — смена тунги',
  'Если токен утерян — перевыпустите его здесь же. Старый перестанет работать сразу.': 'Токен йўқолса — уни шу ерда қайта чиқаринг. Эскиси дарҳол ишламай қолади.',
  'Есть препятствия. Выдача с оговорками требует пояснения — оно попадёт в документ': 'Тўсиқлар бор. Изоҳ билан бериш тушунтиришни талаб қилади — у ҳужжатга тушади',
  'ещё не выгружались': 'ҳали юкланмаган',
  'Ждёт приёмки': 'Қабулни кутмоқда',
  'Ждут одобрения СТК': 'СТК тасдиғини кутмоқда',
  'Жёлтым — то, что сделали не здесь. Его доля и отвечает на вопрос, возвращается ли брак кругом через переплав': 'Сариқ билан — бу ерда қилинмагани. Унинг улуши яроқсиз қайта эритиш орқали айланиб қайтадими деган саволга жавоб беради',
  'живые операции заказов этого участка, в порядке очереди': 'шу участка буюртмаларининг жонли операциялари, навбат тартибида',
  'Журнал анализов': 'Таҳлиллар журнали',
  'За раз не больше 500 — иначе рулон никто не пересчитает': 'Бир мартада 500 тадан кўп эмас — акс ҳолда рулонни ҳеч ким қайта санамайди',
  'Заведена': 'Очилган',
  'Завёл': 'Очди',
  'Завершены': 'Якунланган',
  'Завершить': 'Якунлаш',
  'Завершить работу': 'Ишни якунлаш',
  'Завести тару': 'Идиш очиш',
  'Завести тару под лом': 'Чиқинди учун идиш очиш',
  'Заводит и согласовывает заказы, ведёт ссылки на документы продаж': 'Буюртмаларни очади ва келишади, сотув ҳужжатларига ҳаволаларни юритади',
  'Загружаем': 'Юкланмоқда',
  'Загрузки': 'Юкламалар',
  'Загрузок': 'Юкламалар',
  'Задайте ресурс хотя бы одним счётчиком — иначе инструмент никогда не потребует внимания': 'Ресурсни ҳеч бўлмаса битта ҳисоблагич билан беринг — акс ҳолда асбоб ҳеч қачон эътибор талаб қилмайди',
  'Задайте хотя бы одну границу: без допуска годным будет любое значение': 'Ҳеч бўлмаса битта чегара беринг: допусксиз ҳар қандай қиймат яроқли бўлади',
  'Задание': 'Топшириқ',
  'Заказ · операция': 'Буюртма · операция',
  'Заказ в терминальном статусе, переходы недоступны': 'Буюртма якуний ҳолатда, ўтишлар мавжуд эмас',
  'Заказ встанет, когда материал кончится — подвезите заранее.': 'Материал тугаганда буюртма тўхтайди — олдиндан етказинг.',
  'Заказ не назначен': 'Буюртма тайинланмаган',
  'Заказов на участке нет': 'Участкада буюртмалар йўқ',
  'Заказов нет': 'Буюртмалар йўқ',
  'Заказов пока нет.': 'Ҳозирча буюртмалар йўқ.',
  'Заказы участка': 'Участка буюртмалари',
  'Заключение': 'Хулоса',
  'закончить': 'якунлаш',
  'Закрытие смены': 'Сменани ёпиш',
  'Закрыть с необъяснённым простоем': 'Тушунтирилмаган тўхташ билан ёпиш',
  'Закрыть смену': 'Сменани ёпиш',
  'Замечания к расчёту:': 'Ҳисоб-китобга изоҳлар:',
  'Заморозка снимется, данные снова можно будет править. Кто, когда и зачем переоткрыл — останется в списке правок навсегда.': 'Музлатиш олинади, маълумотларни яна таҳрирлаш мумкин бўлади. Ким, қачон ва нима учун қайта очгани тузатишлар рўйхатида абадий қолади.',
  'Запасной норматив для OEE': 'OEE учун захира норма',
  'Запасной норматив: применяется, только если нет ни нормы операции, ни факта прошлых смен, ни такта изделия': 'Захира норма: фақат операция нормаси ҳам, ўтган сменалар амали ҳам, маҳсулот такти ҳам бўлмаганда қўлланилади',
  'Записал': 'Ёздим',
  'Записал, закрыть': 'Ёздим, ёпиш',
  'Записано, но ещё не обработано или не отправлено': 'Ёзилган, лекин ҳали қайта ишланмаган ёки юборилмаган',
  'Записать правку': 'Тузатишни ёзиш',
  'Записать разрешение': 'Рухсатни ёзиш',
  'Записей': 'Ёзувлар',
  'Записей нет': 'Ёзувлар йўқ',
  'Записи из очереди ушедшего оператора: количество уже в учёте, назовите человека': 'Кетган оператор навбатидаги ёзувлар: миқдор аллақачон ҳисобда, одамни кўрсатинг',
  'Записи не удаляются — только отключаются, чтобы не разрушить историю отчётов.': 'Ёзувлар ўчирилмайди — ҳисоботлар тарихини бузмаслик учун фақат ўчириб қўйилади.',
  'Запись останется зачёркнутой: содержимое бункера — это факт, и дыра в нём объясняется хуже, чем вычеркнутая строка': 'Ёзув чизиб ташланган ҳолда қолади: бункер ичидагиси — бу амалдаги ҳолат, ундаги бўшлиқ чизилган қатордан кўра ёмонроқ тушунтирилади',
  'Заполните только то, что нужно сменить.': 'Фақат алмаштириш керак бўлганини тўлдиринг.',
  'Запуск другого задания приостановит эту операцию — укажите причину': 'Бошқа топшириқни ишга тушириш бу операцияни тўхтатиб туради — сабабни кўрсатинг',
  'Заявлен': 'Билдирилган',
  'Знаков после запятой': 'Каср хоналари',
  'Зон хранения нет. Заведите буферную зону в дереве оборудования — материал учитывается в них': 'Сақлаш зоналари йўқ. Ускуналар дарахтида буфер зонасини очинг — материал уларда ҳисобга олинади',
  'и другие': 'ва бошқалар',
  'и пересчитайте — либо закройте как есть, если причина неизвестна.': 'ва қайта ҳисобланг — ёки сабаб номаълум бўлса, бор ҳолича ёпинг.',
  'Идёт': 'Кетмоқда',
  'Идёт сейчас': 'Ҳозир кетмоқда',
  'из': 'дан',
  'Из выгрузки склада. Пусто — обмен по этой позиции не работает': 'Омбор юкламасидан. Бўш — бу позиция бўйича алмашув ишламайди',
  'Из заказа, если он указан': 'Буюртмадан, агар у кўрсатилган бўлса',
  'из имеющихся': 'мавжудларидан',
  'Из чего его делают': 'У нимадан қилинади',
  'Из чего сделано': 'Нимадан қилинган',
  'Изделие карты не меняется': 'Харита маҳсулоти ўзгармайди',
  'изделий': 'маҳсулот',
  'Излишек — добавить в зону': 'Ортиқча — зонага қўшиш',
  'Изменить': 'Ўзгартириш',
  'Измерено': 'Ўлчанган',
  'Измеряемая': 'Ўлчанадиган',
  'Изолировано': 'Ажратилган',
  'Изолировано, шт': 'Ажратилган, дона',
  'Израсходована': 'Сарфланган',
  'Им оператор входит на терминале вместе с PIN': 'Оператор у билан PIN қўшиб терминалга киради',
  'Именно его спрашивают при рекламации': 'Рекламацияда айнан уни сўрашади',
  'Имя': 'Исм',
  'Имя, логин, табельный': 'Исм, логин, табел',
  'Инструмент закреплён за станками — список ограничен ими': 'Асбоб дастгоҳларга бириктирилган — рўйхат улар билан чекланган',
  'Исключений нет — завод работает по режиму недели. Праздники стоит завести заранее: плановые даты считаются по этому календарю': 'Истиснолар йўқ — завод ҳафта тартиби бўйича ишлайди. Байрамларни олдиндан киритган маъқул: режали саналар шу календарь бўйича ҳисобланади',
  'Использовать как есть': 'Бор ҳолича ишлатиш',
  'История статусов': 'Ҳолатлар тарихи',
  'Итоги пересчитаны': 'Якунлар қайта ҳисобланди',
  'Итого': 'Жами',
  'Их номер': 'Уларнинг рақами',
  'каждая': 'ҳар',
  'каждая деталь': 'ҳар бир детал',
  'Каждая деталь': 'Ҳар бир детал',
  'каждая N-я': 'ҳар N-чи',
  'Каждая N-я': 'Ҳар N-чи',
  'Каждое сообщение записывается до обработки — и то, что мы отправили, и то, что нам прислали. Через месяц это единственное, чем можно ответить на «а этот приход дошёл?».': 'Ҳар бир хабар қайта ишлашдан олдин ёзилади — биз юборганимиз ҳам, бизга юборилгани ҳам. Бир ойдан кейин «бу кирим етиб бордими?» деган саволга фақат шу билан жавоб бериш мумкин.',
  'Как в системе': 'Тизимдагидек',
  'как у изделия': 'маҳсулотдагидек',
  'Какие дни завод работает вообще. Праздники и переносы — ниже': 'Завод умуман қайси кунлари ишлайди. Байрамлар ва кўчиришлар — қуйида',
  'Какой это лом': 'Бу қандай чиқинди',
  'Календарь двигает плановые даты заказов. Остановки отдельных станков сюда не заводятся — они живут в обслуживании и знают, кто их делает': 'Календарь буюртмаларнинг режали саналарини суради. Алоҳида дастгоҳларнинг тўхташи бу ерга киритилмайди — улар техник хизматда туради ва ким қилаётганини билади',
  'Календарь читают через год: «нерабочий день» без причины оставляет только вопросы': 'Календарни бир йилдан кейин ўқишади: сабабсиз «ишламайдиган кун» фақат савол қолдиради',
  'Категория': 'Тоифа',
  'кг': 'кг',
  'Кем произведена': 'Ким ишлаб чиқарган',
  'Клиент отказался, изменение спецификации…': 'Мижоз рад этди, спецификация ўзгарди…',
  'Смотреть можно всё, что доступно вашей роли. Изменения делаются с планшета или компьютера — на ходу с телефона легко нажать не ту кнопку.': 'Ролингизга очиқ ҳамма нарсани кўриш мумкин. Ўзгартиришлар планшет ёки компьютердан қилинади — юриб кетаётиб телефонда нотўғри тугмани босиб юбориш осон.',
  'Код в WMS': 'WMS даги код',
  'Ключ события': 'Ҳодиса калити',
  'Код карты': 'Харита коди',
  'Код показателя': 'Кўрсаткич коди',
  'Код родительской бирки': 'Ота бирка коди',
  'Код с бирки': 'Биркадаги код',
  'Код с бирки образца': 'Намуна биркасидаги код',
  'Код с бирки партии': 'Партия биркасидаги код',
  'Код читается с опечатками в регистре и пробелах. Последняя цифра — контрольная: она не даст открыть чужую партию из-за одной ошибки': 'Код ҳарф катта-кичиклиги ва бўшлиқлардаги хатолар билан ҳам ўқилади. Охирги рақам — назорат рақами: у битта хато туфайли бегона партияни очишга йўл қўймайди',
  'Количество не создаёт, а подтверждает — передаёт дальше свой вход': 'Миқдорни яратмайди, тасдиқлайди — ўз киришини кейинга узатади',
  'Комментарий обязателен': 'Изоҳ мажбурий',
  'Комплектующие': 'Бутловчилар',
  'Компонент': 'Компонент',
  'Контроль': 'Назорат',
  'Контроль качества': 'Сифат назорати',
  'Контрольная операция': 'Назорат операцияси',
  'Контрольная операция: выпуск на ней не регистрируется, дальше по маршруту уходит то же количество, что пришло на вход': 'Назорат операцияси: унда маҳсулот қайд этилмайди, маршрут бўйлаб киришга келган миқдорнинг ўзи кетади',
  'Копировать': 'Нусхалаш',
  'Корень дерева. Обычно один': 'Дарахт илдизи. Одатда битта',
  'Коротко, как в журнале': 'Қисқача, журналдагидек',
  'Корректировка': 'Тузатиш',
  'Корректировка по пересчёту': 'Қайта санаш бўйича тузатиш',
  'Кто сделал брак': 'Яроқсизни ким қилган',
  'Куда вернуть станок': 'Дастгоҳни қаерга қайтариш',
  'Лаборатория': 'Лаборатория',
  'линейный маршрут': 'чизиқли маршрут',
  'Лить такой лом в плавку значит вернуть в металл ту же беду, из-за которой он и стал ломом. Смотрите источники ниже': 'Бундай чиқиндини эритишга қуйиш — уни чиқиндига айлантирган бало металлга қайтариш демакдир. Қуйидаги манбаларга қаранг',
  'Логин': 'Логин',
  'Лом': 'Чиқинди',
  'любое': 'ҳар қандай',
  'Любое происхождение': 'Ҳар қандай келиб чиқиш',
  'Любое состояние': 'Ҳар қандай ҳолат',
  'Любой вид': 'Ҳар қандай тур',
  'любые': 'ҳар қандай',
  'М.П.': 'М.Ў.',
  'Маршрут не разузлован — это происходит при согласовании заказа': 'Маршрут ёйилмаган — бу буюртма келишилганда бўлади',
  'Маршрут пуст. Добавьте хотя бы одну операцию — по ним заказ разузловывается.': 'Маршрут бўш. Ҳеч бўлмаса битта операция қўшинг — буюртма улар бўйича ёйилади.',
  'Маршрутные карты': 'Маршрут хариталари',
  'Маршрутных карт нет.': 'Маршрут хариталари йўқ.',
  'Маршруты': 'Маршрутлар',
  'масса ед.': 'бирлик массаси',
  'Материал испорчен и в производство не пойдёт. Из остатка уходит безвозвратно': 'Материал бузилган ва ишлаб чиқаришга кетмайди. Қолдиқдан қайтариб бўлмайдиган тарзда чиқади',
  'Материал остаётся в цехе, но меняет зону хранения': 'Материал сехда қолади, лекин сақлаш зонасини алмаштиради',
  'Материал списан, но его поступление не оформлено. Проведите подвоз или разберитесь с расходом.': 'Материал ҳисобдан чиқарилган, лекин кирими расмийлаштирилмаган. Етказишни ўтказинг ёки сарф билан аниқлик киритинг.',
  'Материалы в цехе': 'Сехдаги материаллар',
  'Материалы ведутся отдельно от номенклатуры. Полуфабрикат заводится в обоих справочниках, поле «Изделие» связывает записи явно.': 'Материаллар номенклатурадан алоҳида юритилади. Ярим тайёр маҳсулот иккала маълумотномага ҳам киритилади, «Маҳсулот» майдони ёзувларни очиқ боғлайди.',
  'Меньше — лучше. Разрывы допустимы: 1, 2, 5 — чтобы потом вставить уровень между ними без перенумерации': 'Кичикроқ — яхшироқ. Узилишлар мумкин: 1, 2, 5 — кейин улар орасига қайта рақамламасдан даража қўшиш учун',
  'мера': 'ўлчов',
  'Место': 'Жой',
  'Месяц': 'Ой',
  'Минимальный остаток': 'Энг кам қолдиқ',
  'Минимум': 'Энг ками',
  'мм': 'мм',
  'Момент, когда материал переехал из кладовой в цех. Одна запись на подвоз, а не на смену': 'Материал омборхонадан сехга ўтган пайт. Битта ёзув — битта етказишга, сменага эмас',
  'н/д': 'м/й',
  'На доработку': 'Қайта ишлашга',
  'На единицу': 'Бирликка',
  'На каждом переделе': 'Ҳар бир босқичда',
  'На операциях': 'Операцияларда',
  'На переточке': 'Қайта чархлашда',
  'на переточку': 'қайта чархлашга',
  'На связи': 'Алоқада',
  'На эту партию сертификатов нет. Передать можно, но при рекламации доказывать будет нечем': 'Бу партияга сертификат йўқ. Узатиш мумкин, лекин рекламацияда исботлашга ҳеч нима бўлмайди',
  'На эту партию уже выдавались': 'Бу партияга аллақачон берилган',
  'На эту смену задание не выдано. Оператор увидит всю очередь участка — это не поломка, но что делать в первую очередь, ему никто не сказал.': 'Бу сменага топшириқ берилмаган. Оператор участканинг бутун навбатини кўради — бу носозлик эмас, лекин аввал нима қилишни унга ҳеч ким айтмаган.',
  'Название в этой карте': 'Бу харитадаги номи',
  'Назначить': 'Тайинлаш',
  'Назовите день: календарь читают через год, и «нерабочий день» без причины оставляет только вопросы': 'Кунга ном беринг: календарни бир йилдан кейин ўқишади ва сабабсиз «ишламайдиган кун» фақат савол қолдиради',
  'Найти': 'Топиш',
  'Накладная': 'Юк хати',
  'Накопитель. OEE по нему не считается': 'Тўплагич. Бўйича OEE ҳисобланмайди',
  'накопленная доля': 'жамланган улуш',
  'Напечатайте бирку в разделе «Партии» и повесьте на бункер. Пока бирки нет, тара есть в системе и нет в цехе': 'Биркани «Партиялар» бўлимида чоп этинг ва бункерга осинг. Бирка йўқ экан, идиш тизимда бор, сехда эса йўқ',
  'Напишите причину: инструмент стоит денег, и вопрос «почему» зададут': 'Сабабни ёзинг: асбоб пул туради ва «нега» деган савол берилади',
  'Наработка': 'Ишлаб бериш',
  'Наработка в строке — снимок на момент события, а не сумма за всю жизнь: отсчёт идёт от последней переточки': 'Қатордаги ишлаб бериш — ҳодиса пайтидаги ҳолат, бутун умр бўйича йиғинди эмас: ҳисоб охирги қайта чархлашдан боради',
  'Наработка запишется снимком': 'Ишлаб бериш ҳолат сифатида ёзилади',
  'Наработка запишется снимком — от неё пойдёт отсчёт до следующего срока': 'Ишлаб бериш ҳолат сифатида ёзилади — кейинги муддатгача ҳисоб шундан боради',
  'Наработка пересчитается сама: она считается по фактам, а не хранится числом': 'Ишлаб бериш ўзи қайта ҳисобланади: у сон бўлиб сақланмайди, амалдаги ҳолат бўйича ҳисобланади',
  'Наработка считается по выпуску станка за время, пока инструмент на нём стоял, и отсчитывается от последней переточки. Отдельного счётчика нет намеренно: он разошёлся бы с отчётами на первом же сторно': 'Ишлаб бериш асбоб дастгоҳда турган вақтдаги маҳсулот бўйича ҳисобланади ва охирги қайта чархлашдан бошланади. Алоҳида ҳисоблагич атайлаб йўқ: у биринчи стернодаёқ ҳисоботлардан ажралиб кетарди',
  'Наработка считается по журналу состояний — только время, когда станок работал. Отдельного счётчика нет намеренно: он разошёлся бы с журналом на первой же правке задним числом': 'Ишлаб бериш ҳолатлар журнали бўйича ҳисобланади — фақат дастгоҳ ишлаган вақт. Алоҳида ҳисоблагич атайлаб йўқ: у орқага қайтиб қилинган биринчи тузатишдаёқ журналдан ажралиб кетарди',
  'Настроить': 'Созлаш',
  'Настройка контура: справочники, дерево, терминалы, пользователи': 'Контурни созлаш: маълумотномалар, дарахт, терминаллар, фойдаланувчилар',
  'Настройки': 'Созламалар',
  'Настройки предприятия': 'Корхона созламалари',
  'Начали': 'Бошладик',
  'Начало': 'Бошланиши',
  'Начало и конец совпадают': 'Бошланиши ва охири бир хил',
  'Начальник ОТК': 'СТК бошлиғи',
  'Начать': 'Бошлаш',
  'Начать работу': 'Ишни бошлаш',
  'Нашла': 'Топди',
  'нашла чужого больше, чем сделала своего': 'ўзи қилганидан кўра бегонасини кўпроқ топган',
  'не более': 'кўпи билан',
  'Не более, %': 'Кўпи билан, %',
  'не выдано': 'берилмаган',
  'Не выполнены: за это время обстановка изменилась. Решайте по факту': 'Бажарилмаган: бу вақт ичида вазият ўзгарди. Амалдаги ҳолатга қараб ҳал қилинг',
  'не выполнялось': 'бажарилмаган',
  'Не годен': 'Яроқсиз',
  'не доехало:': 'етиб бормади:',
  'Не дошедшие приходы никто не повторит сам — нажмите «Повторить» или включите автоповтор в настройках': 'Етиб бормаган киримларни ҳеч ким ўзи такрорламайди — «Такрорлаш»ни босинг ёки созламаларда автотакрорни ёқинг',
  'Не дошло': 'Етиб бормади',
  'не закреплён за устройством': 'қурилмага бириктирилмаган',
  'не короче 8 символов': '8 белгидан қисқа эмас',
  'не менее': 'ками билан',
  'Не менее, %': 'Ками билан, %',
  'не мерено': 'ўлчанмаган',
  'не обязательно': 'мажбурий эмас',
  'Не отменять': 'Бекор қилинмасин',
  'не привязана': 'боғланмаган',
  'не привязано': 'боғланмаган',
  'не присвоен': 'берилмаган',
  'не сопоставлено': 'мослаштирилмаган',
  'не сохранено:': 'сақланмади:',
  'не точится': 'чархланмайди',
  'не указан': 'кўрсатилмаган',
  'Не указана': 'Кўрсатилмаган',
  'не успевает': 'улгурмаяпти',
  'Неделя': 'Ҳафта',
  'Недостача — списать из зоны': 'Камомад — зонадан ҳисобдан чиқариш',
  'Незавершённые действия с рабочих мест': 'Иш жойларидаги тугалланмаган амаллар',
  'Незакрытых операций на участке нет': 'Участкада ёпилмаган операциялар йўқ',
  'Незакрытых сообщений нет — всё, что отправляли и принимали за сутки, доехало.': 'Ёпилмаган хабарлар йўқ — сутка давомида юборилган ва қабул қилинганларнинг ҳаммаси етиб борди.',
  'необязательная': 'мажбурий эмас',
  'Нерабочий день': 'Ишламайдиган кун',
  'Несоответствие': 'Номувофиқлик',
  'нет — вне планового времени': 'йўқ — режали вақтдан ташқарида',
  'нет входа': 'кириш йўқ',
  'Нет готовых заданий для этого участка. Задание появится, когда предыдущая операция передаст количество.': 'Бу участка учун тайёр топшириқлар йўқ. Олдинги операция миқдорни узатганда топшириқ пайдо бўлади.',
  'нет данных': 'маълумот йўқ',
  'Нет данных для расчёта за период': 'Давр учун ҳисоб-китоб маълумотлари йўқ',
  'Нет данных за период': 'Давр учун маълумот йўқ',
  'Нет доступного оборудования': 'Мавжуд ускуна йўқ',
  'Нет доступных вариантов': 'Мавжуд вариантлар йўқ',
  'Нет подходящих родителей — сначала создайте узел уровнем выше': 'Мос ота тугунлар йўқ — аввал бир даража юқорида тугун яратинг',
  'нет такта': 'такт йўқ',
  'Ни один показатель не заполнен': 'Бирорта кўрсаткич тўлдирилмаган',
  'ни разу не выполнялось': 'ҳеч қачон бажарилмаган',
  'Ниже': 'Пастроқ',
  'Ниже него подсвечивается нехватка. Пусто — не следим': 'Ундан пастда камомад ёритилади. Бўш — кузатилмайди',
  'Нижняя граница больше верхней': 'Пастки чегара юқорисидан катта',
  'Ничего не выбрано — весь день целиком. Смены отмечают, когда стоит не завод, а одна смена: например, ночная перед праздником': 'Ҳеч нима танланмаган — бутун кун. Сменалар завод эмас, битта смена тўхтаганда белгиланади: масалан, байрам олдидан тунги смена',
  'Ничего не выбрано — где угодно. Так и оставьте, если ограничения в цехе нет: выдуманный запрет наладчик обойдёт мимо системы': 'Ҳеч нима танланмаган — исталган жойда. Сехда чеклов бўлмаса, шундайлигича қолдиринг: ўйлаб топилган тақиқни созловчи тизимни четлаб ўтади',
  'Ничего не ждёт приёмки. Здесь появляются операции, выпуск которых нельзя передать дальше без разрешения контролёра.': 'Ҳеч нима қабулни кутмаяпти. Бу ерда маҳсулотини назоратчи рухсатисиз кейинга узатиб бўлмайдиган операциялар пайдо бўлади.',
  'Новая единица измерения': 'Янги ўлчов бирлиги',
  'Новая карта': 'Янги харита',
  'Новая партия поставщика': 'Етказиб берувчининг янги партияси',
  'новая по накладной': 'юк хати бўйича янги',
  'Новая причина': 'Янги сабаб',
  'Новая смена': 'Янги смена',
  'Новое изделие': 'Янги маҳсулот',
  'Новое табло': 'Янги табло',
  'Новый вид операции': 'Янги операция тури',
  'Новый заказ': 'Янги буюртма',
  'Новый материал': 'Янги материал',
  'Новый пароль': 'Янги парол',
  'Новый уровень качества': 'Янги сифат даражаси',
  'Новый PIN': 'Янги PIN',
  'Ноль — не перетачивается: отработал и списан': 'Нол — чархланмайди: ишлаб бўлди ва ҳисобдан чиқарилди',
  'Номенклатура': 'Номенклатура',
  'Номер и название обязательны': 'Рақам ва ном мажбурий',
  'Номер или партия': 'Рақам ёки партия',
  'номер накладной': 'юк хати рақами',
  'Номер операции': 'Операция рақами',
  'Номер поставщика': 'Етказиб берувчи рақами',
  'Номер, партия, документ, контрагент': 'Рақам, партия, ҳужжат, контрагент',
  'Номера операций повторяются — они должны быть уникальны': 'Операция рақамлари такрорланмоқда — улар такрорланмас бўлиши керак',
  'Номера уже закреплены за вашим предприятием. Если лист не напечатается, бирки не пропадут — их можно найти в списке и напечатать снова.': 'Рақамлар аллақачон корхонангизга бириктирилган. Варақ чоп этилмаса, биркалар йўқолмайди — уларни рўйхатдан топиб, қайта чоп этиш мумкин.',
  'Номера через 10 — чтобы можно было вставить операцию между': 'Рақамлар 10 тадан — орасига операция қўшиш мумкин бўлиши учун',
  'норма': 'норма',
  'Норма на годное': 'Яроқлига норма',
  'Норма по умолчанию, сек/ед': 'Стандарт норма, сек/бирл.',
  'Норма, с/ед': 'Норма, с/бирл.',
  'Нормативы': 'Нормалар',
  'Ночная': 'Тунги',
  'ночная смена — переходит через полночь': 'тунги смена — ярим тундан ўтади',
  'Нужен для сводки в тоннах. Пусто — тонны не показываются': 'Тоннадаги ҳисобот учун керак. Бўш — тонналар кўрсатилмайди',
  'нужен контроль': 'назорат керак',
  'Нужно для прослеживаемости. Выключите для расходников: партия шлифкруга никому не нужна': 'Кузатувчанлик учун керак. Сарф материаллари учун ўчиринг: чархлаш доирасининг партияси ҳеч кимга керак эмас',
  'Область видимости': 'Кўриш доираси',
  'Обмен': 'Алмашув',
  'Обмен с внешними системами': 'Ташқи тизимлар билан алмашув',
  'Обмен со складом': 'Омбор билан алмашув',
  'Обмена ещё не было. Записи появятся, когда склад пришлёт первое событие или мы отправим первый приход.': 'Ҳали алмашув бўлмаган. Омбор биринчи ҳодисани юборганда ёки биз биринчи киримни юборганда ёзувлар пайдо бўлади.',
  'обмена не было': 'алмашув бўлмаган',
  'Обнаружил': 'Аниқлади',
  'Обозначение по чертежу': 'Чизма бўйича белгиланиши',
  'Обоснование': 'Асос',
  'Обработано по операциям': 'Операциялар бўйича ишланган',
  'Образец отобран': 'Намуна олинди',
  'Обслуживаемые станки': 'Хизмат кўрсатиладиган дастгоҳлар',
  'Обслуживание': 'Техник хизмат',
  'Обслуживание и оснастка: регламенты ТО, установка и переточка инструмента. Смену не закрывает и выпуск не сдаёт': 'Техник хизмат ва асбоблар: ТХ регламентлари, асбобни ўрнатиш ва қайта чархлаш. Сменани ёпмайди ва маҳсулот топширмайди',
  'обязателен': 'мажбурий',
  'Один справочник с категориями: интерфейс подставляет нужный срез оператору и мастеру': 'Тоифали битта маълумотнома: интерфейс оператор ва смена бошлиғига керакли қисмини қўяди',
  'Окончание': 'Тугаши',
  'Окончательный брак': 'Якуний яроқсиз',
  'Оператор': 'Оператор',
  'Оператор забыл PIN — это решается здесь за минуту': 'Оператор PIN ни унутди — бу шу ерда бир дақиқада ҳал бўлади',
  'Операций с планом контроля нет. Характеристики задаются в маршрутной карте': 'Назорат режаси бор операциялар йўқ. Тавсифлар маршрут харитасида берилади',
  'Определяет, где причина предлагается': 'Сабаб қаерда таклиф қилинишини белгилайди',
  'Определяет, чей это брак. «Свой передел» — смены, которая его сделала; «предыдущий» или «химия плавки» — той, что сварила металл. Без этого брак записывается на того, кто его нашёл, и внимательная смена выглядит худшей': 'Бу кимнинг яроқсизи эканини белгилайди. «Ўз босқичи» — уни қилган сменаники; «олдинги» ёки «эритма кимёси» — металлни эритган сменаники. Бусиз яроқсиз уни топган одамга ёзилади ва эътиборли смена энг ёмони бўлиб кўринади',
  'оснастка': 'асбоб',
  'Оснастка': 'Асбоб',
  'Оснастка не заведена. Пока инструмент безымянный, «брак по оснастке» означает «виноват станок», то есть никто: завтра там будет другая фильера, а изношенная уедет на соседний стан и продолжит': 'Асбоблар киритилмаган. Асбоб номсиз экан, «асбоб сабабли яроқсиз» дегани «дастгоҳ айбдор», яъни ҳеч ким: эртага у ерда бошқа фильера туради, эскиргани эса қўшни стангa кетиб давом этади',
  'Остановка завода': 'Заводнинг тўхташи',
  'Остаток': 'Қолдиқ',
  'Ответ': 'Жавоб',
  'Отгружается': 'Жўнатилмоқда',
  'Отказ по смыслу — повторять бесполезно, нужен человек': 'Мазмунан рад этиш — такрорлаш бефойда, одам керак',
  'Отказано': 'Рад этилди',
  'отказов:': 'рад этишлар:',
  'Отклонение навесок от рецепта': 'Шихталарнинг рецептдан четланиши',
  'Отклонение размера': 'Ўлчам четланиши',
  'Отклонения от режима недели. Сильнее его в обе стороны': 'Ҳафта тартибидан четланишлар. Иккала томонга ҳам ундан кучлироқ',
  'Отклонить': 'Рад этиш',
  'Отклонить протокол': 'Баённомани рад этиш',
  'Отключение и перевыпуск токена обрывают работающий экран сразу, не дожидаясь истечения выданного ключа.': 'Токенни ўчириш ва қайта чиқариш ишлаб турган экранни берилган калит муддати тугашини кутмасдан дарҳол узади.',
  'Открытые вызовы с рабочих мест': 'Иш жойларидан очиқ чақирувлар',
  'Открытые несоответствия': 'Очиқ номувофиқликлар',
  'Открытых тар нет. Заведите бункер — без него брак у станка складывать некуда': 'Очиқ идишлар йўқ. Бункер очинг — усиз дастгоҳ ёнидаги яроқсизни қўйишга жой йўқ',
  'Открыть': 'Очиш',
  'Открыть на проверку': 'Текшириш учун очиш',
  'Откуда лом': 'Чиқинди қаердан',
  'Откуда причина': 'Сабаб қаердан',
  'Откуда пришёл металл и куда он ушёл — по коду с бирки': 'Металл қаердан келган ва қаерга кетган — биркадаги код бўйича',
  'Откуда, по источникам': 'Қаердан, манбалар бўйича',
  'Отменены': 'Бекор қилинган',
  'Отменить': 'Бекор қилиш',
  'Отмечено «нужен контроль», но мерить нечего — у контролёра операция не появится': '«Назорат керак» белгиланган, лекин ўлчашга ҳеч нима йўқ — назоратчида операция пайдо бўлмайди',
  'Отправил': 'Юборди',
  'Отправитель не дал идентификатора: повторную доставку от новой не отличить': 'Юборувчи идентификатор бермаган: такрорий етказишни янгисидан ажратиб бўлмайди',
  'Отправить на переточку': 'Қайта чархлашга юбориш',
  'Отправить снова': 'Қайта юбориш',
  'Отправить этот приход складу ещё раз': 'Бу киримни омборга яна бир марта юбориш',
  'Отрицательное «сверх нормы» — не экономия. Обычно это значит, что часть расхода не оформлена, и остаток в системе больше, чем в цехе': 'Манфий «нормадан ортиқ» — тежамкорлик эмас. Одатда бу сарфнинг бир қисми расмийлаштирилмаганини ва тизимдаги қолдиқ сехдагидан кўп эканини билдиради',
  'Отсканируйте бирку того, откуда лом': 'Чиқинди қаердан келганининг биркасини сканерланг',
  'Отчёт за эту смену уже был открыт': 'Бу смена ҳисоботи аллақачон очилган эди',
  'очередь': 'навбат',
  'очередь пуста': 'навбат бўш',
  'Очередь пуста: ничего не просрочено, ресурс нигде не на исходе, незакрытых работ нет. Так и должно выглядеть спокойное утро': 'Навбат бўш: ҳеч ниманинг муддати ўтмаган, ҳеч қаерда ресурс тугамаяпти, ёпилмаган ишлар йўқ. Тинч эрталаб шундай кўриниши керак',
  'ошибка в накладной': 'юк хатидаги хато',
  'Пароли и PIN не хранятся в открытом виде и не показываются — их можно только задать заново.': 'Пароллар ва PIN очиқ ҳолда сақланмайди ва кўрсатилмайди — уларни фақат қайтадан бериш мумкин.',
  'Пароль': 'Парол',
  'Пароль и PIN': 'Парол ва PIN',
  'Пароль не короче 8 символов': 'Парол 8 белгидан қисқа эмас',
  'Партии': 'Партиялар',
  'Партии и бирки': 'Партиялар ва биркалар',
  'Партии поставщика': 'Етказиб берувчи партиялари',
  'Партий нет. Выдайте бирки — они печатаются пустыми и ждут металла': 'Партиялар йўқ. Биркаларни беринг — улар бўш чоп этилади ва металлни кутади',
  'Партия не может быть собственным родителем': 'Партия ўзининг отаси бўла олмайди',
  'Партия передела': 'Босқич партияси',
  'Паспорт': 'Паспорт',
  'Пауза': 'Пауза',
  'первая деталь': 'биринчи детал',
  'Первая деталь': 'Биринчи детал',
  'Передана на склад': 'Омборга топширилган',
  'Передано с оговорками:': 'Изоҳлар билан топширилган:',
  'Передать': 'Топшириш',
  'Передать на склад': 'Омборга топшириш',
  'Переделов назад': 'Неча босқич орқада',
  'Перемещение': 'Кўчириш',
  'Перемещение между зонами': 'Зоналар орасида кўчириш',
  'Переналадки': 'Қайта созлашлар',
  'Перенести с прошлой смены': 'Ўтган сменадан кўчириш',
  'Переоткрыть': 'Қайта очиш',
  'Переоткрыть смену': 'Сменани қайта очиш',
  'Перепечатать выданные': 'Берилганларни қайта чоп этиш',
  'Перерасход материалов': 'Материалларнинг ортиқча сарфи',
  'Перерывы': 'Танаффуслар',
  'Перерывы, мин': 'Танаффуслар, дақ.',
  'Пересчёт разошёлся с учётом. Излишек добавляется в зону, недостача списывается': 'Қайта санаш ҳисоб билан мос келмади. Ортиқчаси зонага қўшилади, камомад ҳисобдан чиқарилади',
  'Пересчитать': 'Қайта ҳисоблаш',
  'Переточен': 'Қайта чархланган',
  'Переточки': 'Қайта чархлашлар',
  'Печать': 'Чоп этиш',
  'Печать бирки': 'Биркани чоп этиш',
  'Печать листа': 'Варақни чоп этиш',
  'Печать предпросмотра': 'Кўриб чиқишни чоп этиш',
  'План контроля': 'Назорат режаси',
  'План контроля пуст': 'Назорат режаси бўш',
  'Плановое': 'Режали',
  'Плановое время за смену, мин': 'Смена учун режали вақт, дақ.',
  'Плановое время, мин': 'Режали вақт, дақ.',
  'Плановые даты заказов пересчитаются сразу: они не хранятся, а считаются': 'Буюртмаларнинг режали саналари дарҳол қайта ҳисобланади: улар сақланмайди, ҳисобланади',
  'По активной карте заказ разузловывается в операции при согласовании': 'Фаол харита бўйича буюртма келишилганда операцияларга ёйилади',
  'По нормам': 'Нормалар бўйича',
  'по норме': 'норма бўйича',
  'По норме': 'Норма бўйича',
  'По происхождению': 'Келиб чиқиши бўйича',
  'По регламенту': 'Регламент бўйича',
  'По терминалу': 'Терминал бўйича',
  'По умолчанию': 'Стандарт',
  'По умолчанию всё, что за биркой. Партия могла ужаться в переделах — на склад уходит то, что реально положили': 'Стандарт ҳолда бирка ортидаги ҳамма нарса. Партия босқичларда камайган бўлиши мумкин — омборга ҳақиқатда қўйилгани кетади',
  'По умолчанию работают все семь дней: у непрерывного производства это так и есть, а поставленная по умолчанию пятидневка сдвинула бы все плановые даты, ничего об этом не сказав': 'Стандарт ҳолда етти кун ҳам ишланади: узлуксиз ишлаб чиқаришда шундай, стандарт қилиб қўйилган беш кунлик эса барча режали саналарни бу ҳақда ҳеч нима демасдан суриб юборарди',
  'По этому отбору записей нет.': 'Бу танлов бўйича ёзувлар йўқ.',
  'повтор вот-вот': 'такрор ҳозир бўлади',
  'Повторите пароль': 'Паролни такрорланг',
  'Повторите пароль — значения не совпадают': 'Паролни такрорланг — қийматлар мос келмаяпти',
  'Повторите PIN': 'PIN ни такрорланг',
  'Повторите PIN — значения не совпадают': 'PIN ни такрорланг — қийматлар мос келмаяпти',
  'Повторить': 'Такрорлаш',
  'Под этот отбор никто не подошёл.': 'Бу танловга ҳеч ким мос келмади.',
  'Под этот отбор ничего не подошло.': 'Бу танловга ҳеч нима мос келмади.',
  'подготовка': 'тайёргарлик',
  'Подготовка на партию': 'Партияга тайёргарлик',
  'Подготовка по умолчанию, с': 'Стандарт тайёргарлик, с',
  'Подготовка, с': 'Тайёргарлик, с',
  'Поднесите сканер или введите код с бирки': 'Сканерни яқинлаштиринг ёки биркадаги кодни киритинг',
  'Подробности': 'Тафсилотлар',
  'Подставить': 'Қўйиш',
  'Подставляется в новый шаг маршрута': 'Маршрутнинг янги қадамига қўйилади',
  'Подтвердить': 'Тасдиқлаш',
  'Подтвердить отмену': 'Бекор қилишни тасдиқлаш',
  'Подтянуть со склада': 'Омбордан тортиб олиш',
  'позиций': 'позиция',
  'Поиск': 'Қидирув',
  'Пойдёт': 'Бўлади',
  'Пока замер вне допуска не разобран, сдать годное по операции нельзя. Брак и дефект сдаются': 'Допускдан ташқари ўлчов кўриб чиқилмагунча операция бўйича яроқлини топшириб бўлмайди. Яроқсиз ва нуқсон топширилади',
  'Пока эти записи не разобраны, смену закрыть нельзя: в замороженном документе подтвердить исполнителя будет уже негде, и работа пропадёт из табеля.': 'Бу ёзувлар кўриб чиқилмагунча сменани ёпиб бўлмайди: музлатилган ҳужжатда бажарувчини тасдиқлашга жой қолмайди ва иш табелдан йўқолади.',
  'Показатели и границы подставятся из состава материала. Если состав не заведён, добавьте показатели руками — администратор потом занесёт их в справочник': 'Кўрсаткичлар ва чегаралар материал таркибидан қўйилади. Таркиб киритилмаган бўлса, кўрсаткичларни қўлда қўшинг — администратор кейин уларни маълумотномага киритади',
  'Показать все': 'Ҳаммасини кўрсатиш',
  'Показать все заказы': 'Барча буюртмаларни кўрсатиш',
  'Показать всех': 'Ҳаммани кўрсатиш',
  'Показывает': 'Кўрсатади',
  'показывается один раз — перепишите сейчас': 'бир марта кўрсатилади — ҳозир кўчириб ёзинг',
  'показывать отключённых': 'ўчирилганларни кўрсатиш',
  'Полноэкранное табло для цехового экрана': 'Сех экрани учун тўлиқ экранли табло',
  'Положить': 'Солиш',
  'Положить лом': 'Чиқинди солиш',
  'Пользователей пока нет': 'Ҳозирча фойдаланувчилар йўқ',
  'Пользователи': 'Фойдаланувчилар',
  'Пометка к пачке': 'Дастага белги',
  'Пометка складу': 'Омборга белги',
  'пометки': 'белгилар',
  'Понятно': 'Тушунарли',
  'После': 'Кейин',
  'После закрытия данные смены заморожены: сторнировать отчёты и править причины будет нельзя.': 'Ёпилгандан кейин смена маълумотлари музлатилади: ҳисоботларни сторно қилиш ва сабабларни таҳрирлаш мумкин бўлмайди.',
  'После передачи партия выходит из MES. Дальше её ведёт склад — и код бирки должен переехать на складскую этикетку': 'Топширилгандан кейин партия MES дан чиқади. Уни кейин омбор юритади — бирка коди эса омбор ёрлиғига кўчиши керак',
  'Последние движения': 'Охирги ҳаракатлар',
  'последняя в партии': 'партиядаги охиргиси',
  'Последняя в партии': 'Партиядаги охиргиси',
  'Посмотреть рабочее место оператора': 'Оператор иш жойини кўриш',
  'поставить': 'ўрнатиш',
  'Поставить': 'Ўрнатиш',
  'Поступила': 'Келиб тушди',
  'Поступление': 'Кирим',
  'Поступление на участок': 'Участкага кирим',
  'Потери времени': 'Вақт йўқотишлари',
  'Потерь за период не зарегистрировано': 'Давр учун йўқотишлар қайд этилмаган',
  'Почему не допущен': 'Нега рухсат берилмаган',
  'Почему эта работа не засчитывается?': 'Нега бу иш ҳисобга олинмаяпти?',
  'Пояснение': 'Тушунтириш',
  'ППР, инвентаризация, отключение энергии': 'РПТ, инвентаризация, энергияни ўчириш',
  'Пр.': 'Уст.',
  'правится': 'таҳрирланмоқда',
  'правка': 'тузатиш',
  'Правка не затронет уже разузлованные заказы — их операции зафиксированы': 'Тузатиш маршрути ёйилган буюртмаларга тегмайди — уларнинг операциялари қайд этилган',
  'Правка не переписывает списанное по норме — она встаёт рядом. Иначе исчезнет сама величина расхождения, ради которой правка и нужна.': 'Тузатиш норма бўйича ҳисобдан чиқарилганини қайта ёзмайди — у ёнига қўйилади. Акс ҳолда тузатиш нима учун керак бўлган фарқнинг ўзи йўқолади.',
  'Правки': 'Тузатишлар',
  'Правки и подтверждение': 'Тузатишлар ва тасдиқлаш',
  'Праздник или объявленный выходной': 'Байрам ёки эълон қилинган дам олиш куни',
  'Праздники, переносы и остановки': 'Байрамлар, кўчиришлар ва тўхташлар',
  'Предприятие → цех → участок → станок. Буферные зоны — узлы того же дерева': 'Корхона → сех → участка → дастгоҳ. Буфер зоналари — шу дарахтнинг тугунлари',
  'ПРЕДПРОСМОТР': 'КЎРИБ ЧИҚИШ',
  'Предыдущая версия выключена: активной может быть одна карта на изделие': 'Олдинги версия ўчирилди: ҳар бир маҳсулот учун битта харита фаол бўлади',
  'Прежние анализы этой партии': 'Бу партиянинг олдинги таҳлиллари',
  'Привязать': 'Боғлаш',
  'Привязать металл': 'Металлни боғлаш',
  'Привязать металл к бирке': 'Металлни биркага боғлаш',
  'Привязывается только к оборудованию — не к цеху и не к буферной зоне': 'Фақат ускунага боғланади — сехга ҳам, буфер зонасига ҳам эмас',
  'Приёмка передела': 'Босқични қабул қилиш',
  'Применено на той стороне': 'У томонда қўлланилди',
  'Примечание к закрытию': 'Ёпишга эслатма',
  'Примечание.': 'Эслатма.',
  'Принял': 'Қабул қилди',
  'Принять': 'Қабул қилиш',
  'Принять решение': 'Қарор қабул қилиш',
  'Приход на склад': 'Омборга кирим',
  'Причина — часть выпуска не принята': 'Сабаб — маҳсулотнинг бир қисми қабул қилинмади',
  'Причина отмены': 'Бекор қилиш сабаби',
  'Причина переоткрытия — она останется в документе': 'Қайта очиш сабаби — у ҳужжатда қолади',
  'Причина приостановки текущего задания': 'Жорий топшириқни тўхтатиб туриш сабаби',
  'Причины': 'Сабаблар',
  'Проверка итогов, правки, затем заморозка документа': 'Якунларни текшириш, тузатишлар, сўнг ҳужжатни музлатиш',
  'Провести': 'Ўтказиш',
  'Продукция соответствует заявленному уровню качества и допущена к отгрузке.': 'Маҳсулот эълон қилинган сифат даражасига мос келади ва жўнатишга рухсат этилган.',
  'Производственная дата': 'Ишлаб чиқариш санаси',
  'Произвольная, для отбора': 'Ихтиёрий, танлаш учун',
  'Произвольная, для фильтров': 'Ихтиёрий, филтрлар учун',
  'Прослеживаемость': 'Кузатувчанлик',
  'просрочено': 'муддати ўтган',
  'Простои': 'Тўхташлар',
  'Простой': 'Тўхташ',
  'Простой без причины': 'Сабабсиз тўхташ',
  'Протокол лаборатории не приложен.': 'Лаборатория баённомаси илова қилинмаган.',
  'Протокол останется видимым: разбор через полгода не должен упереться в дыру, которую никто не объяснит. Уровень с партии не снимается': 'Баённома кўриниб туради: ярим йилдан кейинги таҳлил ҳеч ким тушунтирмайдиган бўшлиққа тиралмаслиги керак. Партиядан даража олинмайди',
  'протоколов': 'баённома',
  'Пункты без кнопки пока заводятся через API — экраны для них добавляются по шагам.': 'Тугмасиз бандлар ҳозирча API орқали киритилади — улар учун экранлар босқичма-босқич қўшилади.',
  'пусто — бессрочно': 'бўш — муддатсиз',
  'Пусто — доступ ко всему предприятию. Выбранный узел открывает и всё, что под ним': 'Бўш — бутун корхонага кириш. Танланган тугун остидаги ҳамма нарсани ҳам очади',
  'Пусто — операцию можно назначить на любой участок': 'Бўш — операцияни исталган участкага тайинлаш мумкин',
  'Пусто — причина доступна везде. «Износ шлифкруга» осмысленна не на всех станках': 'Бўш — сабаб ҳамма жойда мавжуд. «Чархлаш доирасининг ейилиши» ҳамма дастгоҳда ҳам маънoли эмас',
  'Пусто — считается как длительность минус перерывы': 'Бўш — давомийлик минус танаффуслар сифатида ҳисобланади',
  'Пусто или 1 — один оператор: вход следующего закрывает смену предыдущего. Больше — бригада: смены копятся, и каждый отмечается своим PIN. Число плановое, превышение не запрещается — забытая чужая смена не должна оставлять пришедшего без работы': 'Бўш ёки 1 — битта оператор: кейингисининг кириши олдингисининг сменасини ёпади. Кўпроқ — бригада: сменалар тўпланади ва ҳар ким ўз PIN и билан белгиланади. Сон режавий, ошиб кетиш тақиқланмайди — унутилган бегона смена келган одамни ишсиз қолдирмаслиги керак',
  'Работаем там, где по режиму недели выходной': 'Ҳафта тартиби бўйича дам олиш бўлган жойда ишлаймиз',
  'Работает': 'Ишлаяпти',
  'Работает на терминале: старт операции, выпуск, вызов мастера. Нужны табельный номер и PIN': 'Терминалда ишлайди: операция бошланиши, маҳсулот, смена бошлиғини чақириш. Табел рақами ва PIN керак',
  'Работник': 'Ходим',
  'Рабочий день': 'Иш куни',
  'развилка после': 'кейин айри',
  'Разница': 'Фарқ',
  'Разобрано': 'Кўриб чиқилган',
  'Разобрать': 'Кўриб чиқиш',
  'Разрешённые участки': 'Рухсат этилган участкалар',
  'Расход': 'Сарф',
  'Расход материала': 'Материал сарфи',
  'Расход материала на единицу': 'Бирликка материал сарфи',
  'Расход со склада': 'Омбордан сарф',
  'Расходные материалы': 'Сарф материаллари',
  'расчёт по очереди участков, без переналадок и выходных': 'участкалар навбати бўйича ҳисоб, қайта созлаш ва дам олишларсиз',
  'Расчётная доля': 'Ҳисобланган улуш',
  'Расчётная доля — оценка, а не измерение: бригадный выпуск поделён поровну между теми, кто был у станка в момент сдачи. Начислять по ней нельзя без решения о том, что бригадный выпуск делится именно так': 'Ҳисобланган улуш — ўлчов эмас, баҳо: бригада маҳсулоти топшириш пайтида дастгоҳ ёнида бўлганлар орасида тенг бўлинган. Бригада маҳсулоти айнан шундай бўлинади деган қарор бўлмаса, унга қараб ҳисоблаб бўлмайди',
  'Регламент': 'Регламент',
  'Регламентов нет. Заведите их в настройке — без регламента обслуживание не наступит никогда, и система о нём не напомнит': 'Регламентлар йўқ. Уларни созламаларда киритинг — регламентсиз техник хизмат ҳеч қачон келмайди ва тизим у ҳақда эслатмайди',
  'Режим недели': 'Ҳафта тартиби',
  'ресурс выработан, переточек не осталось': 'ресурс тугади, қайта чархлаш қолмади',
  'ресурс выработан, пора на переточку': 'ресурс тугади, қайта чархлаш вақти',
  'Ресурс до переточки': 'Қайта чархлашгача ресурс',
  'Рецепт': 'Рецепт',
  'Решение': 'Қарор',
  'решение — не с телефона': 'қарор — телефондан эмас',
  'Решение примет мастер: документ нужен, чтобы на вопрос «кто пропустил эту партию и на каком основании» был ответ.': 'Қарорни смена бошлиғи қабул қилади: ҳужжат «бу партияни ким ва қандай асосда ўтказган» деган саволга жавоб бўлиши учун керак.',
  'Решение принимает мастер или руководство': 'Қарорни смена бошлиғи ёки раҳбарият қабул қилади',
  'Решить': 'Ҳал қилиш',
  'Родитель': 'Ота тугун',
  'Родословная': 'Келиб чиқиш занжири',
  'Роль': 'Рол',
  'Роль определяет доступные экраны, область видимости — какую часть предприятия видно': 'Рол мавжуд экранларни белгилайди, кўриш доираси — корхонанинг қайси қисми кўринишини',
  'С этой минуты весь выпуск станка идёт инструменту в наработку — и брак по оснастке будет назван его номером': 'Шу дақиқадан бошлаб дастгоҳнинг бутун маҳсулоти асбобнинг ишлаб беришига ёзилади — асбоб сабабли яроқсиз эса унинг рақами билан аталади',
  'с/ед': 'с/бирл.',
  'Сверх нормы': 'Нормадан ортиқ',
  'Светлая тема': 'Ёруғ мавзу',
  'Свободен': 'Бўш',
  'Связей нет: партия ни из чего не выведена и никуда пока не пошла': 'Боғланишлар йўқ: партия ҳеч нимадан чиқарилмаган ва ҳозирча ҳеч қаерга кетмаган',
  'Сдал лично': 'Шахсан топширди',
  'сдано лично · расчётная доля': 'шахсан топширилган · ҳисобланган улуш',
  'Сдача годного закрыта': 'Яроқлини топшириш ёпилган',
  'Сделала': 'Қилди',
  'Сделано': 'Бажарилди',
  'Сделать активной': 'Фаол қилиш',
  'Сейчас выполняется': 'Ҳозир бажарилмоқда',
  'сек': 'сек',
  'сек/ед': 'сек/бирл.',
  'Сертификат качества': 'Сифат сертификати',
  'Сертификатов пока нет. Отсканируйте бирку партии': 'Ҳозирча сертификатлар йўқ. Партия биркасини сканерланг',
  'Сертификаты': 'Сертификатлар',
  'Сеть или таймаут — повторить можно': 'Тармоқ ёки таймаут — такрорлаш мумкин',
  'Система ничего не выполнила намеренно: «завершить», нажатое три часа назад, закрыло бы операцию, над которой уже работает сменщик. Нужное действие сделайте сами на экране участка, затем отметьте здесь.': 'Тизим атайлаб ҳеч нима қилмади: уч соат олдин босилган «якунлаш» устида алмашувчи аллақачон ишлаётган операцияни ёпиб қўярди. Керакли амални участка экранида ўзингиз бажаринг, сўнг шу ерда белгиланг.',
  'Сканируйте бирки того, из чего это вышло. Можно несколько — плавка, пруток, оснастка. Пустой список означает, что металл пришёл со стороны': 'Бу нимадан чиққан бўлса, ўшанинг биркаларини сканерланг. Бир нечта бўлиши мумкин — эритма, стержен, асбоб. Бўш рўйхат металл четдан келганини билдиради',
  'склад': 'омбор',
  'Сколько бирок печатать?': 'Нечта бирка чоп этилсин?',
  'Сколько брака дала каждая партия ниже по переделам. Считается по родословной': 'Ҳар бир партия кейинги босқичларда қанча яроқсиз берган. Келиб чиқиш занжири бўйича ҳисобланади',
  'Сколько выходных единиц получается из входных': 'Кирувчи бирликлардан қанча чиқувчи бирлик олинади',
  'Сколько деталей отложено до решения': 'Қарор чиққунча нечта детал ажратиб қўйилган',
  'Сколько передаётся': 'Қанча топширилмоқда',
  'Сколько переточек выдерживает': 'Нечта қайта чархлашга чидайди',
  'сколько успеете': 'қанчага улгурсангиз',
  'Скопировано': 'Нусхаланди',
  'скоро': 'яқинда',
  'Скрыть': 'Яшириш',
  'Следующий': 'Кейингиси',
  'Случаев': 'Ҳолатлар',
  'Смена закрыта. Данные заморожены': 'Смена ёпилди. Маълумотлар музлатилди',
  'Смена переоткрыта, данные снова можно править. Запись осталась в документе': 'Смена қайта очилди, маълумотларни яна таҳрирлаш мумкин. Ёзув ҳужжатда қолди',
  'Смена родителя переносит узел вместе со всем поддеревом': 'Ота тугунни алмаштириш тугунни бутун ост дарахти билан кўчиради',
  'Сменное задание': 'Смена топшириғи',
  'Сменные отчёты': 'Смена ҳисоботлари',
  'Смены задают производственную дату. Ночная смена целиком относится к суткам своего начала.': 'Сменалар ишлаб чиқариш санасини белгилайди. Тунги смена тўлиқ ўз бошланган суткасига тегишли.',
  'Сначала заведите номенклатуру и виды операций — из них собирается карта.': 'Аввал номенклатура ва операция турларини киритинг — харита улардан йиғилади.',
  'Сначала заведите станки в дереве оборудования — терминал привязывается к ним.': 'Аввал ускуналар дарахтида дастгоҳларни киритинг — терминал уларга боғланади.',
  'Сначала устраните причину отказа — иначе ответ будет тот же': 'Аввал рад этиш сабабини бартараф этинг — акс ҳолда жавоб ўша бўлади',
  'Снимите для уровней, которые заказчику не уходят и годятся только в переплав': 'Буюртмачига кетмайдиган ва фақат қайта эритишга яроқли даражалар учун олиб ташланг',
  'Снят': 'Ечилган',
  'Снять': 'Ечиш',
  'Снять со станка': 'Дастгоҳдан ечиш',
  'Собираются из партии, анализа и родословной. Уходят заказчику': 'Партия, таҳлил ва келиб чиқиш занжиридан йиғилади. Буюртмачига кетади',
  'Собрано из сроков обслуживания и ресурса оснастки. Сначала то, что уже идёт: станок в этот момент стоит, и закрыть работу важнее, чем начать следующую': 'Техник хизмат муддатлари ва асбоб ресурсидан йиғилган. Аввал кетаётгани: дастгоҳ шу пайт тўхтаб турибди ва ишни ёпиш кейингисини бошлашдан муҳимроқ',
  'Собрать': 'Йиғиш',
  'Собрать задание': 'Топшириқ йиғиш',
  'Событий нет: инструмент заведён, но ни разу не ставился': 'Ҳодисалар йўқ: асбоб киритилган, лекин ҳеч қачон ўрнатилмаган',
  'Согласовал': 'Келишди',
  'согласовано с заказчиком, письмо №…': 'буюртмачи билан келишилган, хат №…',
  'Согласованы': 'Келишилган',
  'Создайте первый — кнопка «Новый заказ».': 'Биринчисини яратинг — «Янги буюртма» тугмаси.',
  'Создал': 'Яратди',
  'Создать': 'Яратиш',
  'Создать в статусе': 'Қайси статусда яратилсин',
  'Сорт': 'Нав',
  'Состав и допуски. Границы можно оставить пустыми — показатель тогда записывается для истории, но вердикт по нему не выносится': 'Таркиб ва допусклар. Чегараларни бўш қолдириш мумкин — у ҳолда кўрсаткич тарих учун ёзилади, лекин бўйича ҳукм чиқарилмайди',
  'Спецификация': 'Спецификация',
  'Списан': 'Ҳисобдан чиқарилган',
  'Списание': 'Ҳисобдан чиқариш',
  'Списание необратимо. Запись останется: на неё ссылается разбор брака': 'Ҳисобдан чиқариш қайтарилмайди. Ёзув қолади: яроқсиз таҳлили унга ҳавола қилади',
  'Списание порчи': 'Бузилганини ҳисобдан чиқариш',
  'Списано': 'Ҳисобдан чиқарилган',
  'Списано руками': 'Қўлда ҳисобдан чиқарилган',
  'Списать': 'Ҳисобдан чиқариш',
  'списывать': 'ҳисобдан чиқариш',
  'Справочник материалов пуст — заведите материалы в закладке «Материалы»': 'Материаллар маълумотномаси бўш — материалларни «Материаллар» бўлимида киритинг',
  'Справочник материалов пуст — заведите материалы в настройках': 'Материаллар маълумотномаси бўш — материалларни созламаларда киритинг',
  'Справочники склада': 'Омбор маълумотномалари',
  'Сразу на переточку': 'Дарҳол қайта чархлашга',
  'срок не задан': 'муддат берилмаган',
  'Сроки': 'Муддатлар',
  'станки': 'дастгоҳлар',
  'Станок один — оператору он подставится автоматически, выбирать не придётся': 'Дастгоҳ битта — операторга у ўзи қўйилади, танлаш шарт бўлмайди',
  'Станок по умолчанию': 'Стандарт дастгоҳ',
  'Станок свободен': 'Дастгоҳ бўш',
  'Станок уйдёт в ТО автоматически: незакрытое «работает» на стоящем станке портит доступность в OEE': 'Дастгоҳ ўзи техник хизматга ўтади: тўхтаб турган дастгоҳдаги ёпилмаган «ишлаяпти» OEE мавжудлигини бузади',
  'Старый токен перестанет действовать немедленно, привязка к устройству снимется, а работающий экран погаснет и попросит настройку.': 'Эски токен дарҳол ишламай қолади, қурилмага боғланиш олинади, ишлаб турган экран эса ўчиб, созлашни сўрайди.',
  'Старый токен перестанет работать немедленно. Терминал, на котором он прописан, выйдет из строя до ввода нового — оператор не сможет войти.': 'Эски токен дарҳол ишламай қолади. У ёзилган терминал янгиси киритилгунга қадар ишламайди — оператор кира олмайди.',
  'Сторнировать движение': 'Ҳаракатни сторно қилиш',
  'Сторнировать загрузку': 'Юкламани сторно қилиш',
  'сторно': 'сторно',
  'строка': 'қатор',
  'Строка расхода заполняется целиком: материал и норма больше нуля': 'Сарф қатори тўлиқ тўлдирилади: материал ва нолдан катта норма',
  'Структура предприятия и справочники': 'Корхона тузилмаси ва маълумотномалар',
  'Сутки': 'Сутка',
  'Счёт / заказ': 'Ҳисоб / буюртма',
  'Считать потерей': 'Йўқотиш деб ҳисоблаш',
  'Сырьё и заготовки': 'Хомашё ва заготовкалар',
  'Табель': 'Табел',
  'Табельный номер': 'Табел рақами',
  'Табло': 'Табло',
  'Табло не заведено. Экран в цехе можно повесить и без него — мастер открывает андон со своего компьютера, — но тогда его придётся открывать заново каждую смену.': 'Табло киритилмаган. Сехдаги экранни усиз ҳам осиш мумкин — смена бошлиғи андонни ўз компьютеридан очади, — лекин у ҳолда уни ҳар сменада қайтадан очиш керак бўлади.',
  'такт изделия из справочника': 'маълумотномадаги маҳсулот такти',
  'Такт изделия используется для OEE, когда у заказа нет маршрута или норма не задана в операции.': 'Маҳсулот такти буюртмада маршрут бўлмаганда ёки операцияда норма берилмаганда OEE учун ишлатилади.',
  'Такт нужен для производительности в OEE, когда норма не задана в операции. Плановое время — если станок работает не всю смену.': 'Такт операцияда норма берилмаганда OEE унумдорлиги учун керак. Режали вақт — дастгоҳ бутун смена ишламаса.',
  'Такт станка — последняя ступень расчёта норматива: берётся, только если нет ни нормы операции, ни факта прошлых смен, ни такта изделия': 'Дастгоҳ такти — норманы ҳисоблашнинг охирги босқичи: фақат операция нормаси ҳам, ўтган сменалар амали ҳам, маҳсулот такти ҳам бўлмаганда олинади',
  'Такт, с': 'Такт, с',
  'Тара заведена:': 'Идиш очилди:',
  'Тара опорожнена': 'Идиш бўшатилди',
  'Тара пуста': 'Идиш бўш',
  'Телефон — только просмотр.': 'Телефон — фақат кўриш.',
  'Тело сообщения': 'Хабар танаси',
  'Тёмная тема': 'Қоронғи мавзу',
  'Терминалов в цехе меньше, чем станков: их ставят там, где нужен учёт. Один терминал может обслуживать несколько станков участка.': 'Сехда терминаллар дастгоҳлардан кам: улар ҳисоб керак бўлган жойга қўйилади. Битта терминал участканинг бир неча дастгоҳига хизмат қилиши мумкин.',
  'Терминалов нет': 'Терминаллар йўқ',
  'Терминалы': 'Терминаллар',
  'Только входное сырьё: номер, сертификат и срок годности — свойства того, что пришло со стороны. Свои партии живут на экране «Партии», у них родословная и уровень качества. Номер уникален в пределах материала: у двух поставщиков он вполне может совпасть.': 'Фақат кирувчи хомашё: рақам, сертификат ва яроқлилик муддати — четдан келганнинг хоссалари. Ўз партиялари «Партиялар» экранида туради, уларда келиб чиқиш занжири ва сифат даражаси бор. Рақам материал доирасида такрорланмас: икки етказиб берувчида у мос келиши мумкин.',
  'Только для оборудования': 'Фақат ускуна учун',
  'Только для полуфабрикатов, которые вы сами и производите': 'Фақат ўзингиз ишлаб чиқарадиган ярим тайёр маҳсулотлар учун',
  'тонну': 'тоннани',
  'Тот же материал, что и у металла: лом стали 45 остаётся сталью 45, и в плавку он пойдёт как она': 'Металл билан бир хил материал: 45-пўлат чиқиндиси 45-пўлат бўлиб қолади ва эритишга ўша сифатида кетади',
  'Точность': 'Аниқлик',
  'Точность определяет, сколько знаков после запятой принимается в выпуске.': 'Аниқлик маҳсулотда нечта каср хонаси қабул қилинишини белгилайди.',
  'Требовать комментарий': 'Изоҳни талаб қилиш',
  'Требует внимания до закрытия:': 'Ёпишдан олдин эътибор талаб қилади:',
  'Требуют решения': 'Қарор талаб қилади',
  'У пользователя нет табельного номера — PIN не заработает, пока он не задан': 'Фойдаланувчининг табел рақами йўқ — у берилмагунча PIN ишламайди',
  'У этого материала ещё нет партий — заведите новую по накладной': 'Бу материалда ҳали партиялар йўқ — юк хати бўйича янгисини очинг',
  'У этого станка регламентов нет. Заведите в настройке или отметьте работу внеплановой': 'Бу дастгоҳда регламентлар йўқ. Созламаларда киритинг ёки ишни режадан ташқари деб белгиланг',
  'Убрать строку': 'Қаторни олиб ташлаш',
  'Удалить': 'Ўчириш',
  'Узел': 'Тугун',
  'Узлы не удаляются — только отключаются. Отключение блокируется, если есть вложенные объекты, активные терминалы или незакрытые заказы.': 'Тугунлар ўчирилмайди — фақат ўчириб қўйилади. Ички объектлар, фаол терминаллар ёки ёпилмаган буюртмалар бўлса, ўчириб қўйиш блокланади.',
  'Укажите вес больше нуля': 'Нолдан катта вазнни кўрсатинг',
  'Укажите дату': 'Санани кўрсатинг',
  'Укажите количество больше нуля': 'Нолдан катта миқдорни кўрсатинг',
  'Укажите обозначение по чертежу и название характеристики': 'Чизма бўйича белгиланишни ва тавсиф номини кўрсатинг',
  'Укажите шаг выборки: каждую какую деталь проверять': 'Танлаб олиш қадамини кўрсатинг: ҳар неччанчи детал текширилсин',
  'Укажите, какой это лом': 'Бу қандай чиқинди эканини кўрсатинг',
  'Указывают на пропавшие коды склада:': 'Йўқолган омбор кодларига ишора қилади:',
  'Указываются при отмене заказа': 'Буюртма бекор қилинганда кўрсатилади',
  'Унёс брак': 'Яроқсиз олиб кетди',
  'Уровень брака': 'Яроқсизлик даражаси',
  'Уровни качества': 'Сифат даражалари',
  'успевает': 'улгуряпти',
  'Успеем': 'Улгурамиз',
  'Установить на станок': 'Дастгоҳга ўрнатиш',
  'Установлен': 'Ўрнатилган',
  'Устройство': 'Қурилма',
  'Устройство в цехе, с которого оператор отчитывается о выпуске': 'Сехдаги қурилма — оператор ундан маҳсулот ҳақида ҳисобот беради',
  'Утвердить': 'Тасдиқлаш',
  'Утверждено': 'Тасдиқланган',
  'Участки': 'Участкалар',
  'Участок или цех': 'Участка ёки сех',
  'Участок: назначение заданий, состояния станков, закрытие смены': 'Участка: топшириқ тайинлаш, дастгоҳ ҳолатлари, сменани ёпиш',
  'Учётные записи не удаляются — только отключаются: за ними стоят отчёты выпуска и история статусов.': 'Ҳисоб ёзувлари ўчирилмайди — фақат ўчириб қўйилади: улар ортида маҳсулот ҳисоботлари ва ҳолатлар тарихи туради.',
  'Ушло на годное': 'Яроқлига кетди',
  'факт прошлых смен на этом станке': 'шу дастгоҳдаги ўтган сменалар амали',
  'факт прошлых смен на этом станке с этим изделием': 'шу дастгоҳда шу маҳсулот билан ўтган сменалар амали',
  'факт прошлых смен по этому переходу': 'шу ўтиш бўйича ўтган сменалар амали',
  'Фильера': 'Фильера',
  'Химический состав': 'Кимёвий таркиб',
  'Химия': 'Кимё',
  'Хотя бы один день недели должен быть рабочим — иначе планировать некуда': 'Ҳафтанинг ҳеч бўлмаса бир куни иш куни бўлиши керак — акс ҳолда режалаштиришга жой йўқ',
  'Хотя бы один. Если заданы оба — сработает тот, что наступит раньше': 'Ҳеч бўлмаса биттаси. Иккаласи ҳам берилса — аввал келадигани ишлайди',
  'Цвет': 'Ранг',
  'Целевые показатели': 'Мақсадли кўрсаткичлар',
  'Цель': 'Мақсад',
  'Цель за смену': 'Смена учун мақсад',
  'цель не задана': 'мақсад берилмаган',
  'Цех': 'Сех',
  'Цехов и участков в дереве нет': 'Дарахтда сехлар ва участкалар йўқ',
  'Цеховые терминалы': 'Сех терминаллари',
  'часов работы станка': 'дастгоҳнинг иш соатлари',
  'Часть дат за горизонтом расчёта — дальше он не считается, и подставлять туда число было бы выдумкой': 'Саналарнинг бир қисми ҳисоб уфқидан ташқарида — ундан нарига ҳисобланмайди, у ерга сон қўйиш эса ўйлаб топиш бўларди',
  'Часть кода': 'Коднинг бир қисми',
  'Часы': 'Соатлар',
  'Чей брак': 'Кимнинг яроқсизи',
  'Человек в бригаде': 'Бригададаги одам',
  'чем мерить': 'нима билан ўлчаш',
  'через': 'кейин',
  'число': 'сон',
  'Что': 'Нима',
  'Что в бункерах цеха и откуда оно там': 'Сех бункерларида нима бор ва у қаердан келган',
  'Что делать': 'Нима қилиш керак',
  'Что делают': 'Нима қилишади',
  'Что за биркой': 'Бирка ортида нима',
  'Что за лом': 'Қандай чиқинди',
  'Что за работа': 'Қандай иш',
  'Что именно и где': 'Айнан нима ва қаерда',
  'Что исправлено или сверено': 'Нима тузатилди ёки солиштирилди',
  'Что лежит на участках и хватит ли на смену. Склад предприятия ведётся отдельно': 'Участкаларда нима ётибди ва сменага етадими. Корхона омбори алоҳида юритилади',
  'Что можно поставить': 'Нимани қўйиш мумкин',
  'Что нажимали': 'Нима босилган',
  'Что обнаружено': 'Нима аниқланди',
  'Что показывает': 'Нимани кўрсатади',
  'Что попадёт в документ': 'Ҳужжатга нима тушади',
  'Что проверяет лаборатория': 'Лаборатория нимани текширади',
  'Что произошло, что предпринято': 'Нима бўлди, нима қилинди',
  'Что сделано': 'Нима қилинди',
  'Что ушло сверх нормы на годном, что унёс брак, что списали руками': 'Яроқлига нормадан ортиқ нима кетди, яроқсиз нимани олиб кетди, қўлда нима ҳисобдан чиқарилди',
  'Что это создало у нас': 'Бу бизда нима яратди',
  'Чья работа': 'Кимнинг иши',
  'Шкала одна на оба конца цикла: вперёд это приёмка, назад — сорт лома. Порядок важнее названий: по нему сравниваются партии.': 'Шкала циклнинг иккала учига битта: олдинга бу қабул, орқага — чиқинди нави. Тартиб номлардан муҳимроқ: партиялар шу бўйича солиштирилади.',
  'Штука': 'Дона',
  'Экономит оператору нажатие в начале смены. Без умолчания выбор обязателен': 'Операторга смена бошида битта босишни тежайди. Стандарт қийматсиз танлов мажбурий',
  'Экран в проходе. Показывает состояние оборудования участка и не умеет ничего больше': 'Ўтиш жойидаги экран. Участка ускуналарининг ҳолатини кўрсатади ва бошқа ҳеч нима қила олмайди',
  'это вы': 'бу сиз',
  'Это же действие переносит табло на другой экран.': 'Худди шу амал таблони бошқа экранга кўчиради.',
  'Это и есть ответ на вопрос, почему дальше пойдёт брак. Всё, что выйдет из этой партии, будет видно по её родословной': 'Нега кейин яроқсиз кетиши саволига жавоб шу. Бу партиядан чиқадиган ҳамма нарса унинг келиб чиқиш занжирида кўринади',
  'Этот номер уже на руках у заказчика. Аннулированный сертификат остаётся видимым и печатается с отметкой — иначе при рекламации предъявят бумагу, которой в системе нет': 'Бу рақам аллақачон буюртмачи қўлида. Кучдан қолдирилган сертификат кўриниб туради ва белги билан чоп этилади — акс ҳолда рекламацияда тизимда йўқ қоғозни кўрсатишади',
  'OEE по оборудованию': 'Ускуналар бўйича OEE',
  'PIN — от 4 до 8 цифр': 'PIN — 4 дан 8 гача рақам',
  'PIN для терминала': 'Терминал учун PIN',
  'PIN работает только вместе с табельным номером': 'PIN фақат табел рақами билан бирга ишлайди',
  'Ничего не найдено': 'Ҳеч нима топилмади',
  'Например: закрыто до того, как сменщик отметил выпуск': 'Масалан: алмашувчи маҳсулотни белгилашидан олдин ёпилган',
  'Например: медь ниже нормы, повторный отбор': 'Масалан: мис нормадан паст, қайта намуна олиш',
  'Например: ошибка в количестве': 'Масалан: миқдорда хато',
  'Например: перепутан бункер': 'Масалан: бункер адаштирилган',
  'Например: перепутан образец': 'Масалан: намуна адаштирилган',
  'Например: рулон для печи №2': 'Масалан: 2-печ учун рулон',
  'Например: смена сверена с журналом': 'Масалан: смена журнал билан солиштирилди',
  'Например: у ТЦ-01, площадка А': 'Масалан: ТЦ-01 ёнида, А майдончаси',
  'Например: скол на рабочей кромке': 'Масалан: ишчи қиррада учиб кетиш',
  'Например: стук в шпинделе': 'Масалан: шпинделда тақиллаш',
  'Табло механического цеха': 'Механика сехи таблоси',
  'Терминал токарного участка': 'Токарлик участкаси терминали',
  'Новый год · ППР прокатного участка': 'Янги йил · Прокат участкаси РПТ',
  'Фильера Ø18 твердосплавная': 'Фильера Ø18 қаттиқ қотишмали',
  '{n} комп.': '{n} комп.',
  '{n} показ.': '{n} кўрс.',
  'Передано с оговорками: {list}': 'Изоҳлар билан топширилди: {list}',
  'развилка после {list}': '{list} дан кейин айри',
  'входов {n}': 'киришлар {n}',
  'концов {n}': 'охирлар {n}',
  'Протокол по {batch} допущен': '{batch} бўйича баённомага рухсат берилди',
  'Протокол по {batch} отклонён': '{batch} бўйича баённома рад этилди',
  'партии': 'партия',
  '{res} до переточки': 'қайта чархлашгача {res}',
  ', что раньше': ', қайси бири аввал бўлса',
  '-я': '-чи',
  'каждая {n}-я': 'ҳар {n}-чи',
  'через {n} дн': '{n} кундан кейин',
  'через {n} ч': '{n} соатдан кейин',
  'просрочено на {n} дн': '{n} кунга кечиккан',
  'просрочено на {n} ч': '{n} соатга кечиккан',
  '{n} дн': '{n} кун',
  '{n} ч': '{n} соат',
  '{n} шт': '{n} дона',
  'перебор {n} шт': '{n} дона ортиқча',
  'перебор {n} ч': '{n} соат ортиқча',
  'затвор: {n1}': 'дарвоза: {n1}',
  'оп. {n1} · {n2}': 'оп. {n1} · {n2}',
  '{n1} · оп. {n2} {n3}': '{n1} · оп. {n2} {n3}',
  'Разобрано {n1} при предъявленных {n2}': 'Кўриб чиқилган {n1}, тақдим этилган {n2}',
  '· до {n1} — годно': '· {n1} гача — яроқли',
  'Комментарий{n1}': 'Изоҳ{n1}',
  'от {n1}': '{n1} дан',
  'АННУЛИРОВАН {n1} — {n2}': 'КУЧДАН ҚОЛДИРИЛГАН {n1} — {n2}',
  'Протокол лаборатории от {n1}': '{n1} даги лаборатория баённомаси',
  'Выдал: {n1}': 'Берди: {n1}',
  'Токен устройства для {n1}': '{n1} учун қурилма токени',
  'привязано {n1}': 'боғланган {n1}',
  'чужих попыток: {n1}, последняя {n2} назад': 'бегона уринишлар: {n1}, охиргиси {n2} олдин',
  'Перевыпустить токен {n1}?': '{n1} токени қайта чиқарилсинми?',
  'выгружено {n1}': 'юкланди {n1}',
  '· без пары {n1}': '· жуфтсиз {n1}',
  'подтянуто {n1}': 'тортиб олинди {n1}',
  '· пропало {n1}': '· йўқолди {n1}',
  '· не разобрано {n1}': '· кўриб чиқилмаган {n1}',
  '· завершено {n1}': '· якунланган {n1}',
  ', {n1} мест{n2}': ', {n1} жой{n2}',
  'шт · {n1}': 'дона · {n1}',
  'Задание для {n1}': '{n1} учун топшириқ',
  'пр. {n1}': 'уст. {n1}',
  'готово {n1} из {n2}': '{n2} дан {n1} тайёр',
  'срок {n1}': 'муддат {n1}',
  'цель {n1}{n2}': 'мақсад {n1}{n2}',
  'из {n1} {n2}': '{n1} {n2} дан',
  'брак {n1}': 'яроқсиз {n1}',
  'из {n1} т': '{n1} т дан',
  'Ссылки на документ продаж нет — {n1}': 'Сотув ҳужжатига ҳавола йўқ — {n1}',
  'работы {n1} см': 'иш {n1} смена',
  '· упирается в {n1}': '· {n1} га тиралган',
  'План не посчитан: {n1}': 'Режа ҳисобланмади: {n1}',
  'из {n1} → {n2} {n3}': '{n1} дан → {n2} {n3}',
  'норма {n1} с/ед': 'норма {n1} с/бирл.',
  'факт {n1}': 'амалда {n1}',
  'план {n1} → {n2}': 'режа {n1} → {n2}',
  '· ожидается {n1}': '· кутилмоқда {n1}',
  'Не удалось посчитать потребность по {n1} {n2} — в плане их нет:': '{n1} {n2} бўйича эҳтиёжни ҳисоблаб бўлмади — режада улар йўқ:',
  'оп. {n1}: {n2}': 'оп. {n1}: {n2}',
  'Не хватит на остаток заказа: {n1}. Оформите поступление на участок': 'Буюртма қолдиғига етмайди: {n1}. Участкага киримни расмийлаштиринг',
  '{n1} · правка содержимого': '{n1} · мазмунни таҳрирлаш',
  'Количество{n1}': 'Миқдор{n1}',
  'Показано {n1} из {n2} причин · всего {n3}': '{n2} сабабдан {n1} таси кўрсатилган · жами {n3}',
  'Всего {n1}': 'Жами {n1}',
  'Нет причин в категориях: {n1} — соответствующее действие в цехе выполнить не удастся': 'Тоифаларда сабаблар йўқ: {n1} — сехда тегишли амални бажариб бўлмайди',
  'Ссылка на несуществующую операцию: {n1}. Поправьте связи или верните прежние номера': 'Мавжуд бўлмаган операцияга ҳавола: {n1}. Боғланишларни тўғриланг ёки аввалги рақамларни қайтаринг',
  'сходятся {n1} потока': '{n1} оқим бирлашади',
  '{n1} на': '{n1} га',
  'Обозначение «{n1}» уже есть в этой операции — по нему собирается протокол': '«{n1}» белгиланиши бу операцияда аллақачон бор — баённома шу бўйича йиғилади',
  'Сохранить{n1}': 'Сақлаш{n1}',
  'Осталось настроить: {n1}': 'Созлаш қолди: {n1}',
  '· правил {n1}': '· қоидалар {n1}',
  'Станков без терминала: {n1} ({n2}{n3}) — на них некому отчитываться о выпуске': 'Терминалсиз дастгоҳлар: {n1} ({n2}{n3}) — уларда маҳсулот ҳақида ҳисобот берадиган одам йўқ',
  'закреплён {n1}': 'бириктирилган {n1}',
  'Без табельного номера: {n1} — такой оператор не войдёт на цеховом терминале': 'Табел рақамисиз: {n1} — бундай оператор сех терминалига кира олмайди',
  'вместимость {n1}': 'сиғими {n1}',
  'Без активной карты: {n1} — заказ по такому изделию не согласуется': 'Фаол харитасиз: {n1} — бундай маҳсулот бўйича буюртма келишилмайди',
  'версий: {n1}': 'версиялар: {n1}',
  '{n1} оп.': '{n1} оп.',
  '{n1} ч {n2} м': '{n1} с {n2} д',
  '{n1} мин': '{n1} дақ.',
  '{n1} от {n2}': '{n1}, {n2} дан',
  'Мешает выдаче: {n1}': 'Беришга халақит беради: {n1}',
  'был {n1}': 'эди {n1}',
  'Не заполнено с нормой: {n1}': 'Норма билан тўлдирилмаган: {n1}',
  'По химии подходит «{n1}»': 'Кимё бўйича «{n1}» мос келади',
  'Вне нормы: {n1}': 'Меъёрдан ташқари: {n1}',
  'сейчас {n1}': 'ҳозир {n1}',
  'всего в очереди {n1}': 'навбатда жами {n1}',
  'станков в работе {n1}': 'ишдаги дастгоҳлар {n1}',
  'просрочено {n1}': 'муддати ўтган {n1}',
  'скоро {n1}': 'яқинда {n1}',
  'всего {n1}': 'жами {n1}',
  'исчерпан ресурс {n1}': 'ресурс тугаган {n1}',
  'на станках {n1} из {n2}': '{n2} дан {n1} таси дастгоҳларда',
  'из {n1}': '{n1} дан',
  'Ресурс начнётся заново: переточка возвращает кромку. Останется переточек: {n1}': 'Ресурс қайтадан бошланади: қайта чархлаш қиррани тиклайди. Қайта чархлаш қолади: {n1}',
  '· станков {n1}': '· дастгоҳлар {n1}',
  '· обновлено {n1}': '· янгиланди {n1}',
  '{n1} {n2} с выпуском': '{n1} {n2} маҳсулот билан',
  '{n1} в расчёте': '{n1} ҳисобда',
  'Д {n1} · П {n2} · К {n3}': 'М {n1} · У {n2} · С {n3}',
  'Без расчёта: {n1} — не работали или нет нормативов': 'Ҳисобсиз: {n1} — ишламаган ёки нормалар йўқ',
  '{n1} ед.': '{n1} бирл.',
  'разнесено {n1}': 'тақсимланган {n1}',
  'Разнесено {n1} из {n2} ед. Пока происхождение причин не проставлено и партии не указаны, таблица говорит больше о полноте ввода, чем о сменах': '{n2} бирликдан {n1} таси тақсимланган. Сабабларнинг келиб чиқиши қўйилмаган ва партиялар кўрсатилмаган экан, жадвал сменалар ҳақида эмас, киритишнинг тўлиқлиги ҳақида кўпроқ гапиради',
  'вне рецепта {n1} из {n2}': 'рецептдан ташқари {n2} дан {n1} таси',
  'Под угрозой срока: {n1}': 'Муддат хавф остида: {n1}',
  '· упирается в {n1}{n2}': '· {n1}{n2} га тиралган',
  ': нет норматива на {n1}': ': {n1} га норма йўқ',
  'Смена {n1} мин, очередь по правилу «{n2}».': 'Смена {n1} дақ., навбат «{n2}» қоидаси бўйича.',
  'Цех идёт к нормативу с коэффициентом {n1}': 'Сех нормага {n1} коэффициенти билан боради',
  '(по {n1} закрытым операциям за две недели)': '(икки ҳафта ичида ёпилган {n1} операция бўйича)',
  'Норматив не из маршрута: {n1}.': 'Норма маршрутдан эмас: {n1}.',
  'Окно — {n1} {n2}, завершённых операций в нём {n3}.': 'Ойна — {n1} {n2}, ундаги якунланган операциялар {n3}.',
  'На плановый ремонт снято {n1}% мощности станков.': 'Режали таъмирга дастгоҳлар қувватининг {n1}% и олинган.',
  'Пропущено нерабочих смен: {n1}': 'Ўтказиб юборилган ишламайдиган сменалар: {n1}',
  'Горизонт расчёта — {n1} {n2} вперёд; дальше даты не считаются.': 'Ҳисоб уфқи — {n1} {n2} олдинга; ундан нарига саналар ҳисобланмайди.',
  'Не учитывается: {n1}.': 'Ҳисобга олинмайди: {n1}.',
  'план {n1}': 'режа {n1}',
  'Предъявлено на контроль: {n1}': 'Назоратга тақдим этилган: {n1}',
  '· открытых несоответствий {n1}': '· очиқ номувофиқликлар {n1}',
  'стоп {n1}': 'тўхташ {n1}',
  '{n1} · характеристик {n2} · предъявлено {n3}': '{n1} · тавсифлар {n2} · тақдим этилган {n3}',
  'Неразобранные отклонения: {n1}. Брак и дефект сдавать можно — решение по несоответствию принимает мастер': 'Кўриб чиқилмаган четланишлар: {n1}. Яроқсиз ва нуқсонни топшириш мумкин — номувофиқлик бўйича қарорни смена бошлиғи қабул қилади',
  'ещё {n1}': 'яна {n1}',
  'открытых {n1}': 'очиқ {n1}',
  '{n1} · загрузок {n2}': '{n1} · юкламалар {n2}',
  '{n1} {n2} сделаны не здесь': '{n1} {n2} бу ерда қилинмаган',
  '— это {n1}% бункера.': '— бу бункернинг {n1}% и.',
  '{n1} · смена {n2}': '{n1} · смена {n2}',
  '{n1} · {n2} · сейчас {n3}': '{n1} · {n2} · ҳозир {n3}',
  'На операциях больше, чем по терминалу: {n1} Утверждаются часы из столбца «Утверждено» — проставьте их вручную, иначе смена закроется с недосчитанным временем.': 'Операцияларда терминалдагидан кўп: {n1} «Тасдиқланган» устунидаги соатлар тасдиқланади — уларни қўлда қўйинг, акс ҳолда смена вақти кам ҳисобланган ҳолда ёпилади.',
  'Простои без причины: {n1}': 'Сабабсиз тўхташлар: {n1}',
  'Закрыта {n1}, {n2}.': 'Ёпилган {n1}, {n2}.',
  'Примечание: {n1}': 'Эслатма: {n1}',
  'Отрицательный остаток: {n1}': 'Манфий қолдиқ: {n1}',
  '{n1} в {n2}:': '{n2} да {n1}:',
  'Ниже минимума: {n1}': 'Энг камидан паст: {n1}',
  'при минимуме {n1}': 'энг ками {n1} бўлганда',
  'позиций {n1}': 'позициялар {n1}',
  'обновлено {n1}': 'янгиланди {n1}',
  '{n1} — выйти': '{n1} — чиқиш',
  'Принято {n1}. Ждёт приёмки ещё {n2} — операция пока не закроется': 'Қабул қилинди {n1}. Яна {n2} қабулни кутмоқда — операция ҳозирча ёпилмайди',
  'Принято {n1}. Операцию можно закрывать': 'Қабул қилинди {n1}. Операцияни ёпиш мумкин',
  ', цель {n1}%': ', мақсад {n1}%',
  '{n1} уже в списке': '{n1} аллақачон рўйхатда',
  '{n1} — пустая бирка, за ней ещё нет металла': '{n1} — бўш бирка, унинг ортида ҳали металл йўқ',
  'Правка: {n1}': 'Таҳрирлаш: {n1}',
  'показывать отключённые ()': 'ўчирилганларни кўрсатиш ()',
  'на {n1} передела назад': '{n1} босқич орқада',
  'через {n1} передела': '{n1} босқичдан кейин',
  'повтор через ~{n1} мин': 'такрор ~{n1} дақ. дан кейин',
  '{n1}{n2} п.п. к цели': 'мақсадга {n1}{n2} ф.п.',
  '{n1}{n2} к цели': 'мақсадга {n1}{n2}',
  '{n1} — нажмите, чтобы сменить язык': '{n1} — тилни алмаштириш учун босинг',
  '{n1} из {n2}': '{n2} дан {n1}',
  '· серт. {n1}': '· серт. {n1}',
  'после {n1}': '{n1} дан кейин',
  'Заказ {n1}': 'Буюртма {n1}',
  '{n1} — причина не указана': '{n1} — сабаб кўрсатилмаган',
  'В категории «{n1}» причин нет': '«{n1}» тоифасида сабаблар йўқ',
  'Маршрут {n1}': 'Маршрут {n1}',
  'оп.{n1} → {n2}': 'оп.{n1} → {n2}',
  'Сохранено: {n1}': 'Сақланди: {n1}',
  'цехов {n1}, участков {n2}, станков {n3}': 'сехлар {n1}, участкалар {n2}, дастгоҳлар {n3}',
  'брак {n1}, простои {n2}, паузы {n3}': 'яроқсиз {n1}, тўхташлар {n2}, паузалар {n3}',
  'операторов {n1}, мастеров {n2}, планировщиков {n3}': 'операторлар {n1}, смена бошлиқлари {n2}, режалаштирувчилар {n3}',
  'записей {n1}': 'ёзувлар {n1}',
  'Перенесено из смены {n1}: {n2}': '{n1} сменасидан кўчирилган: {n2}',
  ', пропущено закрытых: {n1}': ', ўтказиб юборилган ёпилганлар: {n1}',
  '{n1} — нажмите, чтобы сменить': '{n1} — алмаштириш учун босинг',
  'Препятствий: {n1}. Документ уйдёт заказчику с оговоркой.': 'Тўсиқлар: {n1}. Ҳужжат буюртмачига изоҳ билан кетади.',
  'Список станков не загрузился: {n1}': 'Дастгоҳлар рўйхати юкланмади: {n1}',
  'Регламенты станка не загрузились: {n1}': 'Дастгоҳ регламентлари юкланмади: {n1}',
  'идёт {n1}{n2}': 'кетмоқда {n1}{n2}',
  'брак и дефект {n1}': 'яроқсиз ва нуқсон {n1}',
  'цель {n1}%': 'мақсад {n1}%',
  'из {n1} произведённых': 'ишлаб чиқарилган {n1} тадан',
  'не менее {n1} {n2}': 'ками билан {n1} {n2}',
  'не более {n1} {n2}': 'кўпи билан {n1} {n2}',
  '{n1}: {n2} {n3} вне допуска {n4}': '{n1}: {n2} {n3} допускдан ташқари {n4}',
  'Справочник причин не загрузился: {n1}': 'Сабаблар маълумотномаси юкланмади: {n1}',
  'Выгружен период {n1} — {n2}. В файл попадают только закрытые смены': '{n1} — {n2} даври юкланди. Файлга фақат ёпилган сменалар тушади',
  'Не удалось выгрузить: {n1}': 'Юклаб бўлмади: {n1}',
  'Смена переоткрыта. Это {n1}-е переоткрытие — стоит посмотреть на порядок закрытия': 'Смена қайта очилди. Бу {n1}-қайта очиш — ёпиш тартибига қараб чиққан маъқул',
  'Простой без причины: {n1} мин. Укажите причины в журнале станков': 'Сабабсиз тўхташ: {n1} дақ. Сабабларни дастгоҳлар журналида кўрсатинг',
  'Создать в статусе:': 'Қайси статусда яратилсин:',
  ' (обязателен для этой причины)': ' (бу сабаб учун мажбурий)',
  'Приёмка — с планшета или компьютера': 'Қабул — планшет ёки компьютердан',
  'все': 'ҳаммаси',
  'Подтвердите действие': 'Амални тасдиқланг',
  ' назад': ' олдин',
  'непосредственно из': 'бевосита',
  'пошло в': 'кетди',
  'номенклатура': 'номенклатура',
  'единицы': 'бирликлар',
  'места': 'жойлар',
  'от склада': 'омбордан',
  'на склад': 'омборга',
  'не задан': 'берилмаган',
  'Бирки выданы': 'Биркалар берилди',
  'Напечатайте лист и держите рулон у рабочего места': 'Варақни чоп этинг ва рулонни иш жойида сақланг',
  'Печатаются пустыми: металл встаёт за биркой позже': 'Бўш чоп этилади: металл бирка ортига кейинроқ туради',
  'лист': 'варақ',
  'листа': 'варақ',
  'листов': 'варақ',
  'по нормам': 'нормалар бўйича',
  'вне норм': 'нормадан ташқари',
  'Движение материала': 'Материал ҳаракати',
  'ед.': 'бирл.',
  'ед': 'бирл.',
  'строке нормы': 'норма қатори',
  'строкам норм': 'норма қаторлари',
  'Для заказа под клиента номер документа продаж обязателен': 'Мижоз буюртмаси учун сотув ҳужжати рақами мажбурий',
  'Внутренний заказ — ссылка на документ продаж не требуется': 'Ички буюртма — сотув ҳужжатига ҳавола талаб қилинмайди',
  'Новая маршрутная карта': 'Янги маршрут харитаси',
  'включено': 'ёқилган',
  'выключено': 'ўчирилган',
  'Свернуть': 'Йиғиш',
  'Добавить позицию': 'Позиция қўшиш',
  'Обновить цель': 'Мақсадни янгилаш',
  'В задание': 'Топшириққа',
  'ни разу': 'ҳеч қачон',
  'Новый терминал': 'Янги терминал',
  'Сохраните токен: повторно он не отображается': 'Токенни сақланг: у қайта кўрсатилмайди',
  'всё предприятие': 'бутун корхона',
  'Новый пользователь': 'Янги фойдаланувчи',
  'Новый узел дерева': 'Дарахтнинг янги тугуни',
  'день': 'кун',
  'дня': 'кун',
  'дней': 'кун',
  'Скрыть допущения': 'Фаразларни яшириш',
  'На чём основан прогноз': 'Прогноз нимага асосланган',
  'смена': 'смена',
  'смен': 'смена',
  'станок не назначен': 'дастгоҳ тайинланмаган',
  'годен': 'яроқли',
  'не годен': 'яроқсиз',
  'значение': 'қиймат',
  'Закрыта': 'Ёпилган',
  'На проверке': 'Текширувда',
  'Утверждено при закрытии смены': 'Смена ёпилганда тасдиқланган',
  'Проверьте часы: по терминалу — это время у станка': 'Соатларни текширинг: терминал бўйича — бу дастгоҳ ёнидаги вақт',
  'причина не указана': 'сабаб кўрсатилмаган',
  'сейчас': 'ҳозир',
  ' · не потеря': ' · йўқотиш эмас',
  'Наладчик': 'Созловчи',
  'Мастер': 'Смена бошлиғи',
  'Норматива нет: ': 'Норма йўқ: ',
  '. Эти операции в срок не посчитаны': '. Бу операциялар муддатга ҳисобланмаган',
  'Сменить пароль и PIN — заполните только нужное': 'Парол ва PIN ни алмаштириш — фақат кераклигини тўлдиринг',
  'Учётные данные': 'Ҳисоб маълумотлари',
  'Нельзя отключить себя': 'Ўзингизни ўчириб бўлмайди',
  'Последний администратор должен остаться': 'Охирги администратор қолиши керак',
  'активна': 'фаол',
  'версия ': 'версия ',
  'без кода': 'кодсиз',
  '— ещё не привязан —': '— ҳали боғланмаган —',
  'склад принял ': 'омбор қабул қилди ',
  'склад ещё не подтвердил приёмку': 'омбор қабулни ҳали тасдиқламаган',
  'Выдать с оговоркой': 'Изоҳ билан бериш',
  'Выдать сертификат': 'Сертификат бериш',
  'Обязательно: чем объясняется выдача': 'Мажбурий: бериш нима билан изоҳланади',
  'материал не указан': 'материал кўрсатилмаган',
  ' (не отгружается)': ' (жўнатилмайди)',
  'без уровня': 'даражасиз',
  'есть выходы': 'чиқишлар бор',
  'Задание на смену: сначала то, что уже идёт': 'Смена топшириғи: аввал аллақачон кетаётгани',
  'Что просрочено и что идёт прямо сейчас': 'Ниманинг муддати ўтган ва ҳозир нима кетмоқда',
  'У чего кончается ресурс и что где стоит': 'Ниманинг ресурси тугаяпти ва нима қаерда турибди',
  ' дн': ' кун',
  'Что случилось': 'Нима бўлди',
  'Почему списываем': 'Нега ҳисобдан чиқарамиз',
  'Паспорт инструмента': 'Асбоб паспорти',
  'Завести оснастку': 'Асбоб киритиш',
  'На операциях больше, чем по терминалу: человек работал без входа либо забыл выйти. Утверждаются часы из последнего столбца — проверьте их прежде, чем закрывать смену': 'Операцияларда терминалдагидан кўп: одам кирмасдан ишлаган ёки чиқишни унутган. Охирги устундаги соатлар тасдиқланади — сменани ёпишдан олдин уларни текширинг',
  'работа / плановое время': 'иш / режали вақт',
  'норматив / время работы': 'норма / иш вақти',
  'годное / произведённое': 'яроқли / ишлаб чиқарилган',
  'За период выпуск не регистрировался': 'Давр учун маҳсулот қайд этилмаган',
  'Причины отключаются свободно: смысл в том, чтобы убрать причину из выбора, сохранив её в уже зарегистрированных отчётах.': 'Сабаблар эркин ўчирилади: мақсад — сабабни танловдан олиб ташлаш ва уни аллақачон қайд этилган ҳисоботларда сақлаб қолиш.',
  'ТЦ-05 · Токарный ЧПУ': 'ТЦ-05 · Токарлик ЧПУ',
  'ООО «Ротор»': '«Ротор» МЧЖ',
  'Диаметр 40h7': 'Диаметр 40h7',
  'Иванов А.П.': 'Алиев С.Н.',
  'Смена A (дневная)': 'Смена А (кундузги)',
  'Корпус КД-100': 'Корпус КД-100',
  'Круг 40 ст.45': 'Доира 40 пўлат 45',
  'Медь': 'Мис',
  'Токарная обработка': 'Токарлик ишлов бериш',
  'Отложено': 'Кечиктирилган',
  'Похоже на повтор уже учтённого расхода. Принято, но не применено — решает человек': 'Аллақачон ҳисобга олинган сарфнинг такрорига ўхшайди. Қабул қилинди, лекин қўлланилмади — қарорни одам қабул қилади',
  'Это не повтор — списать материал': 'Бу такрор эмас — материални ҳисобдан чиқариш',
  'Это повтор — ничего не списывать': 'Бу такрор — ҳеч нима ҳисобдан чиқарилмасин',
  'Это повтор': 'Бу такрор',
  'Это повтор?': 'Бу такрорми?',
  'Расход не будет списан. Запись останется в журнале с вашим объяснением.': 'Сарф ҳисобдан чиқарилмайди. Ёзув журналда сизнинг изоҳингиз билан қолади.',
  'Почему это повтор': 'Нега бу такрор',
  'Например: кладовщик отправил заново после обрыва': 'Масалан: омборчи узилишдан кейин қайта юборди',
  'Не списывать': 'Ҳисобдан чиқарилмасин',
  'Возвратные отходы': 'Қайтариладиган чиқинди',
  'Отходы': 'Чиқинди',
  'Отходы, кг': 'Чиқинди, кг',
  'Отходов на 1000 годного': '1000 яроқлига чиқинди',
  'Отношение к годному, умноженное на тысячу: в килограммах это кг на тонну': 'Яроқлига нисбатан, мингга кўпайтирилган: килограммда бу тоннага кг',
  'Годное': 'Яроқли',
  'бухту': 'ғалтак',
  'в бухте': 'ғалтакда',
  'Норма на бухту задана, а вес бухты — нет. Карта сохранится, но расход по этой строке списываться не будет, пока вес не появится': 'Ғалтакка норма берилган, ғалтак вазни эса йўқ. Карта сақланади, лекин вазн пайдо бўлгунча бу сатр бўйича сарф ҳисобдан чиқарилмайди',
  'Бланк приёма-сдачи смены': 'Сменани топшириш-қабул қилиш бланкаси',
  'Бланк на случай обрыва': 'Алоқа узилган ҳолат учун бланка',
  'Печатается заранее и лежит в кабинете: когда связи нет, печатать уже негде': 'Олдиндан чоп этилади ва кабинетда туради: алоқа йўқолганда чоп этадиган жой қолмайди',
  'Заполняется, когда система недоступна. Записи с листа вводятся в систему, как только связь вернётся': 'Тизим ишламаганда тўлдирилади. Варақдаги ёзувлар алоқа тикланиши билан тизимга киритилади',
  'Оп.': 'Оп.',
  'Бирка партии': 'Партия биркаси',
  'Причина брака': 'Яроқсизлик сабаби',
  'Конец': 'Тугаш',
  'Прочее: вызовы, переналадки, происшествия': 'Бошқаси: чақирувлар, қайта созлашлар, ҳодисалар',
  'Смену сдал': 'Сменани топширди',
  'Смену принял': 'Сменани қабул қилди',
  'Введено в систему: кто и когда': 'Тизимга киритилди: ким ва қачон',
  'поддон': 'поддон',
  '{n1}: по числу бухт на поддоне': '{n1}: поддондаги ғалтаклар сони бўйича',
  'материал': 'материал',
  'бухт →': 'ғалтак →',
  '+ строка': '+ қатор',
  'Без таблицы норма одна на любой поддон — число в строке выше': 'Жадвалсиз норма ҳар қандай поддон учун битта — юқоридаги сатрдаги сон',
  'Тара на бухту и на поддон списывается отметкой «Поддон собран» на терминале, а не сдачей выпуска': 'Ғалтак ва поддонга идиш маҳсулот топшириш билан эмас, терминалдаги «Поддон йиғилди» белгиси билан ҳисобдан чиқарилади',
  'Годного, т': 'Яроқли, т',
  'Произведено, т': 'Ишлаб чиқарилган, т',
  'Масса единицы задаётся у операции или у изделия в номенклатуре': 'Бирлик массаси операцияда ёки номенклатурадаги маҳсулотда берилади',
  'Без массы — не в тоннах': 'Массасиз — тоннада эмас',
  'из {n1} произведённых · {n2} т годного': '{n1} ишлаб чиқарилгандан · {n2} т яроқли',
  'Телефон — только просмотр. Изменения делаются с планшета или компьютера': 'Телефон — фақат кўриш. Ўзгартиришлар планшет ёки компьютердан қилинади',
  'запас в сменах: {n1}': 'сменалардаги захира: {n1}',
  ', запас в сменах: {n1}': ', сменалардаги захира: {n1}',
  '{n1} · смен: {n2}': '{n1} · сменалар: {n2}',
};
